import React, { useState, useRef, useCallback, useEffect } from 'react';
import {
   Box,
   Flex,
   VStack,
   HStack,
   Button,
   Input,
   Textarea,
   Select,
   Checkbox,
   Slider,
   SliderTrack,
   SliderFilledTrack,
   SliderThumb,
   Text,
   Heading,
   IconButton,
   Grid,
   Tabs,
   TabList,
   TabPanels,
   Tab,
   TabPanel,
   FormLabel,
   FormControl,
   Divider,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   useDisclosure,
   useToast,
   Badge,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   NumberInput,
   NumberInputField,
   NumberInputStepper,
   NumberIncrementStepper,
   NumberDecrementStepper,
   Tooltip,
   ButtonGroup,
   Spinner,
   Switch,
} from '@chakra-ui/react';
import {
   Type,
   Hash,
   Calendar,
   User,
   FileText,
   Trash2,
   Eye,
   Download,
   Plus,
   Settings,
   Layout,
   ChevronUp,
   ChevronDown,
   Copy,
   DollarSign,
   Percent,
   Mail,
   Phone,
   Clock,
   Link,
   List,
   CheckSquare,
   Star,
   MapPin,
   Minus,
   Image,
   Edit,
   ChevronLeft,
   ChevronRight,
   AlignVerticalJustifyStart,
   AlignVerticalJustifyCenter,
   AlignVerticalJustifyEnd,
   AlignRight,
   AlignCenter,
   AlignLeft,
   AlignJustify,
   Clipboard,
} from 'lucide-react';
import jsPDF from 'jspdf';
import arial from "../../../../fonts/ARIAL.TTF";
import impact from "../../../../fonts/impact.ttf";
import helvetica from "../../../../fonts/Helvetica.ttf";
import times from "../../../../fonts/times.ttf";
import georgia from "../../../../fonts/georgia.ttf";
import verdanai from "../../../../fonts/VERDANAI.TTF";
import trebuc from "../../../../fonts/trebuc.ttf";
import courierPrime from "../../../../fonts/CourierPrime-Regular.ttf";
import comic from "../../../../fonts/COMIC.TTF";
import anek from "../../../../fonts/AnekGujarati_Condensed-Regular.ttf";
import notoSerif from "../../../../fonts/NotoSerifGujarati-Regular.ttf";
import { addPrintFormat, getPrintFormatById, updatePrintFormat } from '../../../../redux/actions/customizeprintings';
import { useDispatch, useSelector } from 'react-redux';
// import { getSetupFormatById } from '../../../../redux/actions/setupFormat';
import { useParams } from 'react-router-dom';
import QueryEditorPage from './QueryEditorPage';
import {
   convertFromPixels,
   convertToPixels,
   fontFamilyOptions,
   fontStyleOptions,
   getPageHeight,
   getPageWidth,
   PAPER_SIZES,
   textDecorationOptions,
   whiteSpaceOptions,
   wordWrapOptions,
} from '../../../../constants';
import { CLEAR_ONE_PRINT } from '../../../../redux/types';
import { FaBarcode } from 'react-icons/fa';
import { ElementSelectorDrawer } from './components/ElementSelectorDrawer';
import { IoMdArrowRoundBack } from 'react-icons/io';
import Swal from 'sweetalert2';

async function loadFontAsBase64(url) {
   const response = await fetch(url);
   const buffer = await response.arrayBuffer();
   let binary = '';
   const bytes = new Uint8Array(buffer);
   const chunkSize = 0x8000;
   for (let i = 0; i < bytes.length; i += chunkSize) {
      let chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
   }
   return btoa(binary);
}

const InvoiceFormatEditor = () => {
   let params = useParams();
   const url = params['*'];
   const id = params.id;
   const [queryText, setQueryText] = useState('');
   // const { isOpen: isQueryOpen, onOpen: onQueryOpen, onClose: onQueryClose } = useDisclosure();
   const { isOpen: isQueryOpen, onOpen: onQueryOpen, onClose: onQueryClose } = useDisclosure();
   const [loadingId, setLoadingId] = useState(null);

   let button = null;
   const singleEntityPrintQuery = useSelector((state) => state?.customizeprintings?.single?.query || {});
   const singleEntityPrintName = useSelector((state) => state?.customizeprintings?.single?.Name || 'Duplicated');
   const [elements, setElements] = useState({
      pageSize: 'a4',
      customWidth: 595, // Default A4 width
      customHeight: 842, // Default A4 height
      customUnit: 'mm',
      orientation: 'portrait', // 'portrait' or 'landscape'
      elements: [
         // Header with religious text
         {
            id: 'header-blessing',
            type: 'text',
            content: '!! ** Shree Ganeshay Namah ** !!',
            x: 50,
            y: 20,
            width: 495,
            height: 25,
            fontSize: 16,
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
         },
         // Company name
         {
            id: 'company-name',
            type: 'text',
            content: 'SS WEB CREATION',
            x: 50,
            y: 50,
            width: 200,
            height: 30,
            fontSize: 20,
            fontWeight: 'bold',
            color: '#000000',
         },
         // Invoice type
         {
            id: 'invoice-type',
            type: 'text',
            content: 'TAX INVOICE',
            x: 400,
            y: 50,
            width: 150,
            height: 30,
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
         },
         // Company address
         {
            id: 'company-address',
            type: 'text',
            content:
               'OFFICE NO. - 336, 3RD FLOOR, AVADH ARENA,\nOPP. MARVELLA CORIDOOR, NEAR SHYAMBABA TEMPLE, VIP ROAD, VESU\nEmail:info@sswebcreation.in (Ph):0261-35 45 369 , 99 25 25 23 22',
            x: 50,
            y: 80,
            width: 350,
            height: 60,
            fontSize: 10,
            fontWeight: 'normal',
            color: '#000000',
         },
         // GSTIN and other details
         {
            id: 'gstin-details',
            type: 'text',
            content: 'GSTIN: 24BJUPB4388N1ZI\nPAN: BJUPB4388N\nUAN: GJ-22D-0031950',
            x: 400,
            y: 80,
            width: 150,
            height: 60,
            fontSize: 10,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Invoice details section
         {
            id: 'invoice-details',
            type: 'text',
            content: 'Invoice Date: 09-09-2024\nInvoice No.: 150\nDue Date: 09-09-2024\nPlace of Supply: 24-GUJARAT',
            x: 50,
            y: 160,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Bill to section
         {
            id: 'bill-to-header',
            type: 'text',
            content: 'Billed to (Customer):',
            x: 50,
            y: 250,
            width: 150,
            height: 20,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000000',
         },
         {
            id: 'customer-info',
            type: 'text',
            content:
               'RUDRA FASHION\nPLOT NO. 1,2,3, GLOBAL IND Bhestan\nSURAT (Mo):9924289959, 9924289959, 898013\nGSTIN: 24BCGPS4404K1ZJ',
            x: 50,
            y: 270,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Delivery address
         {
            id: 'delivery-header',
            type: 'text',
            content: 'Delivery Address:',
            x: 300,
            y: 250,
            width: 150,
            height: 20,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000000',
         },
         {
            id: 'delivery-info',
            type: 'text',
            content:
               'RUDRA FASHION\nPLOT NO. 1,2,3, GLOBAL IND Bhestan\nSURAT (Mo):9924289959, 9924289959, 898013\nGSTIN: 24BCGPS4404K1ZJ',
            x: 300,
            y: 270,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Items table
         {
            id: 'items-table',
            type: 'table',
            content: 'Items Table',
            x: 50,
            y: 370,
            width: 500,
            height: 120,
            fontSize: 11,
            color: '#000000',
            tableFields: [
               {
                  id: 'sr-no',
                  label: 'Sr',
                  type: 'number',
                  width: 8,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  fontFamily: 'Arial',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '1',
               },
               {
                  id: 'description',
                  label: 'Description of Service',
                  type: 'text',
                  width: 35,
                  alignment: 'left',
                  fontSize: 11,
                  fontWeight: 'normal',
                  fontFamily: 'Arial',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: 'AMC SERVICE CHARGE - NODE',
               },
               {
                  id: 'hsn',
                  label: 'HSN',
                  type: 'text',
                  width: 12,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  fontFamily: 'Arial',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '99831',
               },
               {
                  id: 'quantity',
                  label: 'Qty',
                  type: 'number',
                  width: 10,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  fontFamily: 'Arial',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '1.00',
               },
               {
                  id: 'rate',
                  label: 'Rate',
                  type: 'currency',
                  width: 15,
                  alignment: 'right',
                  fontSize: 11,
                  fontWeight: 'normal',
                  fontFamily: 'Arial',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '3000.00',
               },
               {
                  id: 'amount',
                  label: 'Amount Rs.',
                  type: 'currency',
                  width: 20,
                  alignment: 'right',
                  fontSize: 11,
                  fontWeight: 'normal',
                  fontFamily: 'Arial',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '3000.00',
               },
            ],
            tableData: [
               {
                  id: 'row-1',
                  'sr-no': '1',
                  description: 'AMC SERVICE CHARGE - NODE',
                  hsn: '99831',
                  quantity: '1.00',
                  rate: '3000.00',
                  amount: '3000.00',
               },
               {
                  id: 'row-2',
                  'sr-no': '2',
                  description: 'Web Development Service',
                  hsn: '99832',
                  quantity: '2.00',
                  rate: '1500.00',
                  amount: '3000.00',
               },
            ],
            headerStyle: {
               backgroundColor: '#f8f9fa',
               fontWeight: 'bold',
               fontSize: 11,
               color: '#000000',
            },
            showBorders: true,
            alternateRowColors: false,
            evenRowColor: '#ffffff',
            oddRowColor: '#ffffff',
         },
         // Tax calculations
         {
            id: 'tax-section',
            type: 'text',
            content: 'Sub Total: 3000.00\nADD CGST 9.000%: 270.00\nADD SGST 9.000%: 270.00\nNet Amount Rs.: 3540.00',
            x: 350,
            y: 510,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
            textAlign: 'right',
         },
         // Amount in words
         {
            id: 'amount-words',
            type: 'text',
            content: 'Rupees Three Thousand Five Hundred Forty Only.',
            x: 50,
            y: 510,
            width: 280,
            height: 20,
            fontSize: 11,
            fontWeight: 'bold',
            color: '#000000',
         },
         // Terms and conditions
         {
            id: 'terms-header',
            type: 'text',
            content: 'TERMS & CONDITIONS',
            x: 50,
            y: 550,
            width: 200,
            height: 20,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000000',
         },
         {
            id: 'terms-content',
            type: 'text',
            content:
               '1. SOFTWARE Support Will be Provided for 2 YEAR Only & AMC [Rs 1,00,000 /-] Will be Charged after 2 YEAR.\n2. Not to make any COPIES of this Software.\n3. Product Support will be Provided only during office hours (11.00 AM to 6.00 PM) on working days only.\n4. Any Support Required on [HOLIDAY OR AFTER 6:00 PM ON WORKING DAY] will be Chargeable.\n5. We are not liable in any manner whatsoever for any direct / indirect loss.',
            x: 50,
            y: 570,
            width: 500,
            height: 100,
            fontSize: 9,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Bank details
         {
            id: 'bank-details',
            type: 'text',
            content:
               'Bank Details for RTGS / NEFT:\nBANK: CANARA BANK [SME BRANCH]\nACCOUNT NO: 3887201000219\nIFSC CODE: CNRB0003887',
            x: 50,
            y: 680,
            width: 200,
            height: 80,
            fontSize: 10,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Signature section
         {
            id: 'signature',
            type: 'text',
            content: 'For SS WEB CREATION\n\n\nAuthorised Signatory',
            x: 400,
            y: 680,
            width: 150,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
            textAlign: 'center',
         },
         // Footer blessing
         {
            id: 'footer-blessing',
            type: 'text',
            content: '!! ** Shree Mahaviray Namah ** !!',
            x: 50,
            y: 780,
            width: 495,
            height: 25,
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
         },
      ],
   });
   const [tablePagination, setTablePagination] = useState({});
   const MOVEMENT_STEP = 5;
   const dispatch = useDispatch();

   const [selectedElement, setSelectedElement] = useState(null);
   const [selectedTableField, setSelectedTableField] = useState(null);
   const [draggedElement, setDraggedElement] = useState(null);
   const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
   const [showGrid, setShowGrid] = useState(true);
   const [zoom, setZoom] = useState(1);
   const [activeTab, setActiveTab] = useState(0);
   const [isGenerating, setIsGenerating] = useState(false);
   const [isLoading, setIsLoading] = useState(true);
   const [copiedElement, setCopiedElement] = useState(null);

   const canvasRef = useRef(null);
   const printRef = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const toast = useToast();
   const hasLoadedFormat = useRef(false);
   if (url.includes(`/edit/${id}`)) {
      button = 'Save';
   } else if (url.includes(`/copy/${id}`)) {
      button = 'Copy';
   }

   useEffect(() => {
      if (params.id !== loadingId) {
         setIsLoading(true);
         setLoadingId(params.id);
         dispatch(getPrintFormatById(params.id));
      }
   }, [dispatch, params.id, loadingId]);

   useEffect(() => {
      if (printFormatElements && loadingId === params.id) {
         setElements(printFormatElements);
         setQueryText(singleEntityPrintQuery);
         setIsLoading(false);
      }
   }, [singleEntityPrintQuery, loadingId, params.id]);

   // Copy element function
   const copyElement = (element) => {
      const elementToCopy = {
         ...element,
         id: undefined,
      };
      setCopiedElement(elementToCopy);
      toast({ title: 'Element copied', status: 'success', duration: 2000 });
   };

   // Paste element function
   const pasteElement = () => {
      if (!copiedElement) return;

      const newId = `element-${Date.now()}`;
      const pastedElement = {
         ...copiedElement,
         id: newId,
         x: copiedElement.x + 20, // Offset position slightly
         y: copiedElement.y + 20,
      };

      setElements((prev) => ({
         ...prev,
         elements: [...prev.elements, pastedElement],
      }));

      setSelectedElement(pastedElement);
      setCopiedElement(null);
      toast({ title: 'Element pasted', status: 'success', duration: 2000 });
   };

   useEffect(() => {
      const handleKeyDown = (event) => {
         const isCtrlPressed = event.ctrlKey || event.metaKey;

         if (isCtrlPressed) {
            switch (event.key.toLowerCase()) {
               case 'c':
                  event.preventDefault();
                  if (selectedElement) {
                     copyElement(selectedElement);
                  }
                  break;

               case 'v':
                  event.preventDefault();
                  pasteElement();
                  break;
               default:
                  return;
            }
         }
      };

      const canvas = canvasRef.current;
      if (canvas) {
         canvas.addEventListener('keydown', handleKeyDown);
         // Make sure canvas can receive focus
         canvas.setAttribute('tabIndex', '0');
      }

      return () => {
         if (canvas) {
            canvas.removeEventListener('keydown', handleKeyDown);
         }
      };
   }, [selectedElement, copiedElement]);

   // const printFormatElements = useSelector((state) => JSON.parse(state.setupPrint?.single?.PrintFormat?.html));
   const printFormatElements = useSelector((state) => {
      try {
         return JSON.parse(state?.customizeprintings?.single?.html || elements);
      } catch (e) {
         console.error('Error parsing print format JSON:', e);
         return null;
      }
   });

   // const setupPrint = useSelector((state) => JSON.parse(state.setupPrint.customQuery) || {});

   const bgColor = useColorModeValue('gray.50', 'gray.900');
   const cardBg = useColorModeValue('white', 'gray.800');
   const borderColor = useColorModeValue('gray.200', 'gray.600');
   useEffect(() => {
      setIsLoading(true);
      hasLoadedFormat.current = false;
      dispatch(getPrintFormatById(params.id));
   }, [dispatch, params.id]);

   useEffect(() => {
      if (printFormatElements && !hasLoadedFormat.current) {
         setElements(printFormatElements);
         setQueryText(singleEntityPrintQuery);
         hasLoadedFormat.current = true;
         setIsLoading(false);
      }
   }, [printFormatElements, singleEntityPrintQuery]);

   // Available field types for drag and drop
   const fieldTypes = [
      { id: 'text', label: 'Text', icon: Type, color: '#10B981' },
      { id: 'field', label: 'Field', icon: Hash, color: '#3B82F6' },
      { id: 'date', label: 'Date', icon: Calendar, color: '#F59E0B' },
      { id: 'table', label: 'Table', icon: Layout, color: '#8B5CF6' },
      { id: 'client', label: 'Client Info', icon: User, color: '#EF4444' },
      { id: 'notes', label: 'Notes', icon: FileText, color: '#6B7280' },
      { id: 'line', label: 'Horizontal Line', icon: Minus, color: '#6B7280' },
      { id: 'line', label: 'Vertical Line', orientation: 'vertical', icon: Minus, color: '#6B7280' },
      { id: 'image', label: 'Image', icon: Image, color: '#F97316' },
      {
         id: 'barcode',
         label: 'Barcode',
         icon: FaBarcode,
         color: '#8B5CF6',
         orientation: 'horizontal',
      },
   ];

   // Field types with icons and descriptions
   const tableFieldTypes = [
      { value: 'text', label: 'Text', icon: Type, description: 'Single line text input' },
      { value: 'textarea', label: 'Textarea', icon: FileText, description: 'Multi-line text input' },
      { value: 'number', label: 'Number', icon: Hash, description: 'Numeric input only' },
      { value: 'currency', label: 'Currency', icon: DollarSign, description: 'Currency formatted number' },
      { value: 'percentage', label: 'Percentage', icon: Percent, description: 'Percentage input' },
      { value: 'email', label: 'Email', icon: Mail, description: 'Email address input' },
      { value: 'phone', label: 'Phone', icon: Phone, description: 'Phone number input' },
      { value: 'date', label: 'Date', icon: Calendar, description: 'Date picker input' },
      { value: 'time', label: 'Time', icon: Clock, description: 'Time picker input' },
      { value: 'datetime', label: 'DateTime', icon: Calendar, description: 'Date and time picker' },
      { value: 'url', label: 'URL', icon: Link, description: 'Website URL input' },
      { value: 'select', label: 'Select', icon: List, description: 'Dropdown selection' },
      { value: 'checkbox', label: 'Checkbox', icon: CheckSquare, description: 'True/false checkbox' },
      { value: 'rating', label: 'Rating', icon: Star, description: 'Star rating input' },
      { value: 'address', label: 'Address', icon: MapPin, description: 'Address input field' },
      { value: 'image', label: 'Image', icon: Image, description: 'Image upload field' },
   ];

   const moveElement = (elementId, direction) => {
      if (!elementId) return;

      const moveAmount = 5; // pixels to move
      const element = elements.elements.find((el) => el.id === elementId);
      if (!element) return;

      let newX = element.x;
      let newY = element.y;

      switch (direction) {
         case 'up':
            newY = Math.max(0, element.y - moveAmount);
            break;
         case 'down':
            newY = element.y + moveAmount;
            break;
         case 'left':
            newX = Math.max(0, element.x - moveAmount);
            break;
         case 'right':
            newX = element.x + moveAmount;
            break;
         default:
            return;
      }

      // Use your existing updateElement function
      updateElement(elementId, { x: newX, y: newY });
   };

   const handleKeyDown = useCallback(
      (e) => {
         if (!selectedElement) return;

         // Check if user is typing in an input field
         if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
            return;
         }

         // Prevent default behavior for arrow keys
         if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            e.preventDefault();
         }

         // Determine step size (hold Shift for larger steps)
         const step = e.shiftKey ? MOVEMENT_STEP * 2 : MOVEMENT_STEP;

         switch (e.key) {
            case 'ArrowUp':
               moveElement(selectedElement.id, 'up', step);
               break;
            case 'ArrowDown':
               moveElement(selectedElement.id, 'down', step);
               break;
            case 'ArrowLeft':
               moveElement(selectedElement.id, 'left', step);
               break;
            case 'ArrowRight':
               moveElement(selectedElement.id, 'right', step);
               break;
            case 'Delete':
            case 'Backspace':
               if (selectedElement) {
                  deleteElement(selectedElement.id);
               }
               break;
         }
      },
      [selectedElement, showGrid],
   );
   // Add keyboard event listeners
   useEffect(() => {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [handleKeyDown]);

   // Functions to manage table rows
   const addTableRow = (tableId) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const newRowId = `row-${Date.now()}`;
               const newRow = {};

               // Initialize new row with empty values or placeholders
               element.tableFields.forEach((field) => {
                  newRow[field.id] = '';
               });
               newRow.id = newRowId;

               // Add serial number automatically
               if (element.tableFields.find((f) => f.id === 'sr-no')) {
                  newRow['sr-no'] = (element.tableData.length + 1).toString();
               }

               const updatedTableData = [...(element.tableData || []), newRow];

               // Calculate if we need to go to the next page
               const rowsPerPage = element.rowsPerPage || 10;
               const newTotalPages = Math.ceil(updatedTableData.length / rowsPerPage);

               // FIXED: Initialize pagination if it doesn't exist for this table
               if (!tablePagination[tableId]) {
                  setTablePagination((prev) => ({
                     ...prev,
                     [tableId]: {
                        currentPage: 1,
                        totalPages: newTotalPages,
                     },
                  }));
               }

               const currentPage = tablePagination[tableId]?.currentPage || 1;

               // If the new row would be on a new page, navigate to it
               if (updatedTableData.length > currentPage * rowsPerPage) {
                  setTablePagination((prev) => ({
                     ...prev,
                     [tableId]: {
                        ...(prev[tableId] || {}),
                        currentPage: newTotalPages,
                        totalPages: newTotalPages,
                     },
                  }));
               }

               return {
                  ...element,
                  tableData: updatedTableData,
                  rowsPerPage: rowsPerPage, // Save rowsPerPage to element if it doesn't exist
                  height: Math.max(element.height, 40 + Math.min(updatedTableData.length, rowsPerPage) * 25),
               };
            }
            return element;
         }),
      );
   };

   const deleteTableRow = (tableId, rowId) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const updatedTableData = element.tableData.filter((row) => row.id !== rowId);

               // Reorder serial numbers
               const reorderedData = updatedTableData.map((row, index) => ({
                  ...row,
                  'sr-no': (index + 1).toString(),
               }));

               return {
                  ...element,
                  tableData: reorderedData,
                  height: Math.max(120, 40 + (reorderedData.length + 1) * 25), // Adjust height
               };
            }
            return element;
         }),
      );
   };

   const updateTableRowData = (tableId, rowId, fieldId, value) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const updatedTableData = element.tableData.map((row) => {
                  if (row.id === rowId) {
                     const updatedRow = { ...row, [fieldId]: value };

                     // Auto-calculate amount if quantity and rate are updated
                     if (fieldId === 'quantity' || fieldId === 'rate') {
                        const quantity = parseFloat(updatedRow.quantity || 0);
                        const rate = parseFloat(updatedRow.rate || 0);
                        updatedRow.amount = (quantity * rate).toFixed(2);
                     }

                     return updatedRow;
                  }
                  return row;
               });

               return {
                  ...element,
                  tableData: updatedTableData,
               };
            }
            return element;
         }),
      );
   };

   const duplicateTableRow = (tableId, rowId) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const rowToDuplicate = element.tableData.find((row) => row.id === rowId);
               if (rowToDuplicate) {
                  const newRowId = `row-${Date.now()}`;
                  const duplicatedRow = {
                     ...rowToDuplicate,
                     id: newRowId,
                     'sr-no': (element.tableData.length + 1).toString(),
                  };

                  const updatedTableData = [...element.tableData, duplicatedRow];

                  return {
                     ...element,
                     tableData: updatedTableData,
                     height: Math.max(element.height, 40 + (updatedTableData.length + 1) * 25),
                  };
               }
            }
            return element;
         }),
      );
   };

   const handleMouseDown = useCallback(
      (e, element) => {
         const rect = canvasRef.current.getBoundingClientRect();
         const offsetX = e.clientX - rect.left - element.x * zoom;
         const offsetY = e.clientY - rect.top - element.y * zoom;
         setDraggedElement(element);
         setDragOffset({ x: offsetX, y: offsetY });
         setSelectedElement(element);
         setSelectedTableField(null);
      },
      [zoom],
   );

   const handleMouseMove = useCallback(
      (e) => {
         if (!draggedElement) return;

         const rect = canvasRef.current.getBoundingClientRect();
         const newX = Math.max(0, (e.clientX - rect.left - dragOffset.x) / zoom);
         const newY = Math.max(0, (e.clientY - rect.top - dragOffset.y) / zoom);
         const snapX = showGrid ? Math.round(newX / 10) * 10 : newX;
         const snapY = showGrid ? Math.round(newY / 10) * 10 : newY;

         setElements((prev) => {
            // Safety check
            if (!prev || !prev.elements) {
               console.warn('Invalid elements state in handleMouseMove:', prev);
               return prev;
            }

            return {
               ...prev,
               elements: prev.elements.map((el) => (el.id === draggedElement.id ? { ...el, x: snapX, y: snapY } : el)),
            };
         });
      },
      [draggedElement, dragOffset, zoom, showGrid],
   );

   const handleMouseUp = useCallback(() => {
      setDraggedElement(null);
      setDragOffset({ x: 0, y: 0 });
   }, []);

   const addElement = (type, orientation = 'horizontal') => {
      const isLine = type === 'line';
      const isVertical = isLine && orientation === 'vertical';
      const isBarcode = type === 'barcode';
      const newElement = {
         id: `element-${Date.now()}`,
         type: type,
         content: getDefaultContent(type),
         x: 50,
         y: 50,
         width: isLine ? (isVertical ? 190 : 100) : 200,
         // height: isLine ? (isVertical ? 200 : 200) : 200, // Reduced from 200 to 50 for vertical lines
         height: isLine ? (isVertical ? 190 : 10) : 30,
         fontSize: 12,
         fontWeight: 'normal',
         fontStyle: 'normal', // NEW: italic, oblique, normal
         fontFamily: 'Arial', // NEW: font family
         backgroundColor: 'transparent', // NEW: background color
         wordWrap: 'normal', // NEW: break-word, normal
         whiteSpace: 'nowrap', // NEW: nowrap, pre-wrap, normal
         textDecoration: 'none',
         color: '#000000',
         borderWidth: 0,
         borderStyle: 'solid',
         borderRadius: 0,
         padding: 0,
         opacity: 1,
         textTransform: 'none',
         lineHeight: 1.2,
         letterSpacing: 0,
         // Add line-specific properties
         ...(type === 'line' && {
            rotation: isVertical ? 90 : 0,
            thickness: 1,
            isVertical: isVertical,
         }),
         ...(type === 'image' && {
            src: '', // Base64 or URL
            alt: 'Image',
            objectFit: 'contain', // contain, cover, fill, none, scale-down
            borderRadius: 0,
            opacity: 1,
            placeholder: 'Click to upload image',
         }),
         ...(type === 'barcode' && {
            barcodeValue: '123456789012',
            barcodeType: 'CODE128',
            showText: true, // Show/hide text below barcode
            textPosition: 'bottom', // top, bottom, none
            barWidth: 2,
            barHeight: 50,
            fontSize: 10,
            textMargin: 2,
            backgroundColor: '#FFFFFF',
            foregroundColor: '#000000',
         }),
         // Add table-specific properties
         ...(type === 'table' && {
            tableFields: [
               {
                  id: 'sr-no',
                  label: 'Sr. No',
                  type: 'number',
                  width: 15,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: 'transparent',
                  padding: 4,
                  placeholder: '#',
                  borderWidth: 1,
                  borderColor: '#000000',
               },
               {
                  id: 'description',
                  label: 'Description',
                  type: 'text',
                  width: 40,
                  alignment: 'left',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: 'transparent',
                  padding: 4,
                  placeholder: 'Enter description',
                  borderWidth: 1,
                  borderColor: '#000000',
               },
               {
                  id: 'quantity',
                  label: 'Quantity',
                  type: 'number',
                  width: 15,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: 'transparent',
                  padding: 4,
                  placeholder: '0',
                  borderWidth: 1,
                  borderColor: '#000000',
               },
               {
                  id: 'rate',
                  label: 'Rate',
                  type: 'currency',
                  width: 15,
                  alignment: 'right',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: 'transparent',
                  padding: 4,
                  placeholder: '0.00',
                  borderWidth: 1,
                  borderColor: '#000000',
               },
               {
                  id: 'amount',
                  label: 'Amount',
                  type: 'currency',
                  width: 15,
                  alignment: 'right',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: 'transparent',
                  padding: 4,
                  placeholder: '0.00',
                  borderWidth: 1,
                  borderColor: '#000000',
               },
            ],
            tableData: [
               // Create one default row
               {
                  id: `row-${Date.now()}`,
                  'sr-no': '1',
                  description: '',
                  quantity: '',
                  rate: '',
                  amount: '',
               },
            ],
            showBorders: true,
            showColumnLines: false,
            alternateRowColors: false,
            headerStyle: {
               backgroundColor: '#f8f9fa',
               fontWeight: 'bold',
               fontSize: 11,
               color: '#000000',
            },

            // Pagination settings
            rowsPerPage: 10, // Default rows per page
            showPagination: true, // Enable/disable pagination
            maxRows: 1000, // Maximum number of rows allowed
            showAddButton: true, // Show add row button
            showDeleteButton: true, // Show delete row button
            evenRowColor: '#ffffff', // Even row background color
            oddRowColor: '#f8f9fa', // Odd row background color
            // Initialize pagination state for this table
            currentPage: 1,
         }),
      };
      // Initialize pagination state for new table elements
      if (type === 'table') {
         setTablePagination((prev) => ({
            ...prev,
            [newElement.id]: {
               currentPage: 1,
            },
         }));
      }

      setElements((prev) => {
         // Safety check
         if (!prev || !prev.elements) {
            console.warn('Invalid elements state, initializing:', prev);
            return {
               pageSize: 'a4',
               elements: [newElement],
            };
         }

         return {
            ...prev,
            elements: [...prev.elements, newElement],
         };
      });
   };

   const getDefaultContent = (type) => {
      switch (type) {
         case 'text':
            return 'New Text';
         case 'field':
            return 'Field Value';
         case 'date':
            return 'Date: {{date}}';
         case 'table':
            return 'Items Table';
         case 'client':
            return 'Client Information';
         case 'notes':
            return 'Notes and Terms';
         case 'line':
            return '';
         case 'image':
            return 'Image Placeholder';
         case 'barcode':
            return '123456789012';
         default:
            return 'Element';
      }
   };

   const handleImageUpload = (element, file) => {
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
         const imageData = e.target.result;
         updateElement(element.id, { src: imageData });
         // updateElement(element.id, 'src', imageData);
      };
      reader.onerror = (error) => {
         console.error('Error reading file:', error);
         alert('Error reading the image file');
      };
      reader.readAsDataURL(file);
   };

   const updateElement = (id, keyOrUpdates, updates) => {
      setElements((prev) => {
         if (!prev?.elements) return prev;

         return {
            ...prev,
            elements: prev.elements.map((element) => {
               if (element.id !== id) return element;

               let updatedElement =
                  typeof keyOrUpdates === 'object'
                     ? { ...element, ...keyOrUpdates }
                     : { ...element, [keyOrUpdates]: updates };

               if (updatedElement.type === 'line') {
                  const isVertical = updatedElement.isVertical;

                  if (typeof keyOrUpdates === 'object') {
                     if (keyOrUpdates.width !== undefined || keyOrUpdates.height !== undefined) {
                        if (isVertical) {
                           const newSize = keyOrUpdates.width ?? keyOrUpdates.height;
                           updatedElement.width = newSize;
                           updatedElement.height = newSize;
                        } else {
                           if (keyOrUpdates.width !== undefined) updatedElement.width = keyOrUpdates.width;
                           if (keyOrUpdates.height !== undefined) updatedElement.height = keyOrUpdates.height;
                        }
                     }
                  } else if (keyOrUpdates === 'width' || keyOrUpdates === 'height') {
                     if (isVertical) {
                        updatedElement.width = updates;
                        updatedElement.height = updates;
                     } else {
                        updatedElement[keyOrUpdates] = updates;
                     }
                  }
               }
               // Handle table column lines logic (new functionality)
               if (updatedElement.type === 'table') {
                  // If showColumnLines is being toggled, ensure proper state management
                  if (typeof keyOrUpdates === 'object' && keyOrUpdates.showColumnLines !== undefined) {
                     updatedElement.showColumnLines = keyOrUpdates.showColumnLines;
                  } else if (keyOrUpdates === 'showColumnLines') {
                     updatedElement.showColumnLines = updates;
                  }
               }

               return updatedElement;
            }),
         };
      });

      setSelectedElement((prev) => {
         if (!prev || prev.id !== id) return prev;

         let updatedSelected =
            typeof keyOrUpdates === 'object' ? { ...prev, ...keyOrUpdates } : { ...prev, [keyOrUpdates]: updates };

         if (updatedSelected.type === 'line') {
            const isVertical = updatedSelected.isVertical;

            if (typeof keyOrUpdates === 'object') {
               if (keyOrUpdates.width !== undefined || keyOrUpdates.height !== undefined) {
                  if (isVertical) {
                     const newSize = keyOrUpdates.width ?? keyOrUpdates.height;
                     updatedSelected.width = newSize;
                     updatedSelected.height = newSize;
                  }
               }
            } else if (keyOrUpdates === 'width' || keyOrUpdates === 'height') {
               if (isVertical) {
                  updatedSelected.width = updates;
                  updatedSelected.height = updates;
               }
            }
         }

         return updatedSelected;
      });
   };

   const deleteElement = (id) => {
      setElements((prev) => ({
         ...prev,
         elements: prev.elements.filter((el) => el.id !== id),
      }));
      if (selectedElement && selectedElement.id === id) {
         setSelectedElement(null);
         setSelectedTableField(null);
      }
   };

   const addTableField = (tableId) => {
      const newField = {
         id: `field-${Date.now()}`,
         label: 'New Field',
         type: 'text',
         width: 20,
         alignment: 'left',
         fontSize: 14,
         fontWeight: 'normal',
         color: '#000000',
         backgroundColor: '#ffffff',
         borderColor: '#000000',
         borderWidth: 0,
         borderStyle: 'solid',
         borderRadius: 0,
         padding: 0,
         opacity: 1,
         textTransform: 'none',
         lineHeight: 1.2,
         letterSpacing: 0,
         required: true,
         placeholder: 'Enter value...',
      };

      setElements((prev) => ({
         ...prev,
         elements: prev.elements.map((el) =>
            el.id === tableId
               ? {
                  ...el,
                  tableFields: [...(el.tableFields || []), newField],
               }
               : el,
         ),
      }));

      if (selectedElement && selectedElement.id === tableId) {
         setSelectedElement((prev) => ({
            ...prev,
            tableFields: [...(prev.tableFields || []), newField],
         }));
      }
   };

   const updateTableField = (tableId, fieldId, updates) => {
      setElements((prev) => ({
         ...prev,
         elements: prev.elements.map((el) =>
            el.id === tableId
               ? {
                  ...el,
                  tableFields: el.tableFields.map((field) =>
                     field.id === fieldId ? { ...field, ...updates } : field,
                  ),
               }
               : el,
         ),
      }));

      if (selectedElement && selectedElement.id === tableId) {
         setSelectedElement((prev) => ({
            ...prev,
            tableFields: prev.tableFields.map((field) => (field.id === fieldId ? { ...field, ...updates } : field)),
         }));
      }
   };

   const deleteTableField = (tableId, fieldId) => {
      setElements((prev) => ({
         ...prev,
         elements: prev.elements.map((el) =>
            el.id === tableId
               ? {
                  ...el,
                  tableFields: el.tableFields.filter((field) => field.id !== fieldId),
               }
               : el,
         ),
      }));

      if (selectedElement && selectedElement.id === tableId) {
         setSelectedElement((prev) => ({
            ...prev,
            tableFields: prev.tableFields.filter((field) => field.id !== fieldId),
         }));
      }

      if (selectedTableField && selectedTableField.id === fieldId) {
         setSelectedTableField(null);
      }
   };

   const moveTableField = (tableId, fieldId, direction) => {
      const table = elements.elements.find((el) => el.id === tableId);
      if (!table || !table.tableFields) return;

      const currentIndex = table.tableFields.findIndex((field) => field.id === fieldId);
      const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;

      if (newIndex < 0 || newIndex >= table.tableFields.length) return;

      const newFields = [...table.tableFields];
      [newFields[currentIndex], newFields[newIndex]] = [newFields[newIndex], newFields[currentIndex]];

      setElements((prev) => ({
         ...prev,
         elements: prev.elements.map((el) => (el.id === tableId ? { ...el, tableFields: newFields } : el)),
      }));

      if (selectedElement && selectedElement.id === tableId) {
         setSelectedElement((prev) => ({
            ...prev,
            tableFields: newFields,
         }));
      }
   };
   //working
   const generatePDF = async () => {
      setIsGenerating(true);
      try {
         const doc = new jsPDF('p', 'pt', 'a4');
         const pageHeight = doc.internal.pageSize.height;
         const pageWidth = doc.internal.pageSize.width;
         let currentPage = 1;
         let isFirstPage = true;

         // Helper function to add new page
         const addNewPage = () => {
            doc.addPage();
            currentPage++;
            isFirstPage = false;
         };

         console.log("font test", anek, notoSerif);
         const arialBase64 = await loadFontAsBase64(arial);
         const impactBase64 = await loadFontAsBase64(impact);
         const helveticaBase64 = await loadFontAsBase64(helvetica);
         const timesBase64 = await loadFontAsBase64(times);
         const georgiaBase64 = await loadFontAsBase64(georgia);
         const verdanaiBase64 = await loadFontAsBase64(verdanai);
         const trebucBase64 = await loadFontAsBase64(trebuc);
         const courierPrimeBase64 = await loadFontAsBase64(courierPrime);
         const AnekBase64 = await loadFontAsBase64(anek);
         const NotoSerifBase64 = await loadFontAsBase64(notoSerif);
         const comicBase64 = await loadFontAsBase64(comic);

         doc.addFileToVFS("ARIAL.TTF", arialBase64);
         doc.addFont("ARIAL.TTF", "arial", "normal");

         doc.addFileToVFS("Impact.ttf", impactBase64);
         doc.addFont("Impact.ttf", "impact", "normal");

         doc.addFileToVFS("Helvetica.ttf", helveticaBase64);
         doc.addFont("Helvetica.ttf", "helvetica", "normal");

         doc.addFileToVFS("times.ttf", timesBase64);
         doc.addFont("times.ttf", "times", "normal");

         doc.addFileToVFS("georgia.ttf", georgiaBase64);
         doc.addFont("georgia.ttf", "georgia", "normal");

         doc.addFileToVFS("VERDANAI.TTF", verdanaiBase64);
         doc.addFont("VERDANAI.TTF", "verdana", "normal");

         doc.addFileToVFS("trebuc.ttf", trebucBase64);
         doc.addFont("trebuc.ttf", "trebuchet ms", "normal");

         doc.addFileToVFS("CourierPrime-Regular.ttf", courierPrimeBase64);
         doc.addFont("CourierPrime-Regular.ttf", "courier new", "normal");

         doc.addFileToVFS("AnekGujarati_Condensed-Regular.ttf", AnekBase64);
         doc.addFont("AnekGujarati_Condensed-Regular.ttf", "anek gujarati", "normal");

         doc.addFileToVFS("NotoSerifGujarati-Regular.ttf", NotoSerifBase64);
         doc.addFont("NotoSerifGujarati-Regular.ttf", "noto serif", "normal");

         doc.addFileToVFS("COMIC.TTF", comicBase64);
         doc.addFont("COMIC.TTF", "comic sans ms", "normal");

         // Process each element
         for (const element of elements.elements) {
            const x = element.x;
            const y = element.y;
            const fontSize = element.fontSize;

            // Set font properties
            doc.setFontSize(fontSize);
            console.log("element", element);

            // Handle font family
            if (element.fontFamily) {
               try {
                  doc.setFont(element.fontFamily, element.fontWeight || 'normal');
               } catch (fontError) {
                  console.warn('Font not available, using default:', element.fontFamily);
                  doc.setFont(undefined, element.fontWeight || 'normal');
               }
            } else {
               doc.setFont(undefined, element.fontWeight || 'normal');
            }

            // Set font style (italic, oblique)
            if (element.fontStyle && element.fontStyle !== 'normal') {
               try {
                  doc.setFont(undefined, element.fontWeight || 'normal', element.fontStyle);
               } catch (styleError) {
                  console.warn('Font style not available:', element.fontStyle);
               }
            }

            doc.setTextColor(element.color);

            // Handle different element types
            if (element.type === 'image' && element.src) {
               try {
                  // Enhanced image handling with better error checking
                  let imageData = element.src;

                  // Convert base64 or blob URLs to usable format
                  if (element.src.startsWith('data:')) {
                     imageData = element.src;
                  }

                  // Get image properties
                  const imgProps = doc.getImageProperties(imageData);
                  const pdfWidth = element.width;
                  const pdfHeight = element.height;

                  // Calculate dimensions based on objectFit
                  let finalWidth = pdfWidth;
                  let finalHeight = pdfHeight;
                  let offsetX = 0;
                  let offsetY = 0;

                  if (element.objectFit === 'contain') {
                     const imgRatio = imgProps.width / imgProps.height;
                     const containerRatio = pdfWidth / pdfHeight;

                     if (imgRatio > containerRatio) {
                        finalHeight = pdfWidth / imgRatio;
                        offsetY = (pdfHeight - finalHeight) / 2;
                     } else {
                        finalWidth = pdfHeight * imgRatio;
                        offsetX = (pdfWidth - finalWidth) / 2;
                     }
                  } else if (element.objectFit === 'cover') {
                     const imgRatio = imgProps.width / imgProps.height;
                     const containerRatio = pdfWidth / pdfHeight;

                     if (imgRatio > containerRatio) {
                        finalWidth = pdfHeight * imgRatio;
                        offsetX = (pdfWidth - finalWidth) / 2;
                     } else {
                        finalHeight = pdfWidth / imgRatio;
                        offsetY = (pdfHeight - finalHeight) / 2;
                     }
                  } else if (element.objectFit === 'fill') {
                     finalWidth = pdfWidth;
                     finalHeight = pdfHeight;
                     offsetX = 0;
                     offsetY = 0;
                  }

                  // Draw background if specified
                  if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                     const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                     doc.setFillColor(bgR, bgG, bgB);
                     doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                  }

                  // Draw border if specified
                  if (element.borderWidth > 0) {
                     const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                     doc.setDrawColor(borderR, borderG, borderB);
                     doc.setLineWidth(element.borderWidth);

                     // Handle border styles
                     if (element.borderStyle === 'dashed') {
                        doc.setLineDash([3, 3]);
                     } else if (element.borderStyle === 'dotted') {
                        doc.setLineDash([1, 1]);
                     } else {
                        doc.setLineDash([]);
                     }

                     // Draw border with border radius if specified
                     if (element.borderRadius > 0) {
                        doc.roundedRect(x, y, pdfWidth, pdfHeight, element.borderRadius, element.borderRadius, 'S');
                     } else {
                        doc.rect(x, y, pdfWidth, pdfHeight, 'S');
                     }
                  }

                  // Determine image format
                  let imageFormat = 'JPEG';
                  if (imageData.includes('data:image/png')) {
                     imageFormat = 'PNG';
                  } else if (imageData.includes('data:image/gif')) {
                     imageFormat = 'GIF';
                  } else if (imageData.includes('data:image/webp')) {
                     imageFormat = 'WEBP';
                  }

                  // Add the image with enhanced parameters
                  doc.addImage(
                     imageData,
                     imageFormat,
                     x + offsetX,
                     y + offsetY,
                     finalWidth,
                     finalHeight,
                     undefined,
                     'FAST',
                     element.rotation || 0,
                  );

                  // Add image overlay effects if specified
                  if (element.overlay) {
                     const [overlayR, overlayG, overlayB] = hexToRgb(element.overlay.color || '#000000');
                     doc.setFillColor(overlayR, overlayG, overlayB);
                     doc.setGState(new doc.GState({ opacity: element.overlay.opacity || 0.5 }));
                     doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                     doc.setGState(new doc.GState({ opacity: 1 }));
                  }
               } catch (error) {
                  console.error('Error adding image to PDF:', error);

                  // Enhanced error placeholder
                  const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                  doc.setFillColor(placeholderR, placeholderG, placeholderB);
                  doc.rect(x, y, element.width, element.height, 'F');

                  doc.setDrawColor(200, 200, 200);
                  doc.setLineWidth(1);
                  doc.rect(x, y, element.width, element.height, 'S');

                  // Add broken image icon (simple X)
                  doc.setDrawColor(150, 150, 150);
                  doc.setLineWidth(2);
                  doc.line(x + 10, y + 10, x + element.width - 10, y + element.height - 10);
                  doc.line(x + element.width - 10, y + 10, x + 10, y + element.height - 10);

                  doc.setFontSize(10);
                  doc.setTextColor(128, 128, 128);
                  doc.text('Image not available', x + 10, y + element.height / 2);
               }
            } else if (element.type === 'table' && element.tableFields) {
               // Enhanced table handling with pagination
               const fields = element.tableFields;
               const allRows = element.tableData || [];
               const rowsPerPage = element.rowsPerPage || 10;
               const rowHeight = 20;
               const headerHeight = 25;

               // Calculate how many rows can fit on current page
               const remainingPageHeight = pageHeight - y - 50; // 50px margin from bottom
               const maxRowsOnCurrentPage = Math.floor((remainingPageHeight - headerHeight) / rowHeight);

               // Split data into pages
               const totalPages = Math.ceil(allRows.length / rowsPerPage);

               for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
                  const startRowIndex = pageIndex * rowsPerPage;
                  const endRowIndex = Math.min(startRowIndex + rowsPerPage, allRows.length);
                  const pageRows = allRows.slice(startRowIndex, endRowIndex);

                  // Add new page if not the first page or first table
                  if (pageIndex > 0 || !isFirstPage) {
                     addNewPage();
                  }

                  // Set table position (same position for each page)
                  let currentY = y;

                  // Draw table header
                  let currentX = x;

                  // Set header font properties
                  doc.setFontSize(element.headerStyle.fontSize || 12);
                  doc.setFont(undefined, element.headerStyle.fontWeight || 'bold');

                  // Draw header background and cells
                  fields.forEach((field) => {
                     const fieldWidth = (element.width * field.width) / 100;

                     // Draw header background
                     const [headerBgR, headerBgG, headerBgB] = hexToRgb(
                        element.headerStyle.backgroundColor || '#f8f9fa',
                     );
                     doc.setFillColor(headerBgR, headerBgG, headerBgB);
                     doc.rect(currentX, currentY, fieldWidth, headerHeight, 'F');

                     // Draw header border
                     if (element.showBorders) {
                        doc.setDrawColor(0, 0, 0);
                        doc.setLineWidth(1);
                        doc.rect(currentX, currentY, fieldWidth, headerHeight, 'S');
                     }

                     // Add header text
                     const [headerTextR, headerTextG, headerTextB] = hexToRgb(element.headerStyle.color || '#000000');
                     doc.setTextColor(headerTextR, headerTextG, headerTextB);

                     const headerText = field.label || '';
                     const textX = currentX + (field.padding || 5);
                     const textY = currentY + headerHeight / 2 + (element.headerStyle.fontSize || 12) / 3;

                     doc.text(headerText, textX, textY);
                     currentX += fieldWidth;
                  });

                  currentY += headerHeight;

                  // Draw data rows for this page
                  pageRows.forEach((row, rowIndex) => {
                     currentX = x;
                     const actualRowIndex = startRowIndex + rowIndex;

                     fields.forEach((field) => {
                        const fieldWidth = (element.width * field.width) / 100;

                        // Set cell font properties
                        doc.setFontSize(field.fontSize || 10);
                        doc.setFont(undefined, field.fontWeight || 'normal');

                        // Draw cell background
                        let cellBgColor = '#ffffff';
                        if (element.alternateRowColors) {
                           cellBgColor =
                              actualRowIndex % 2 === 0
                                 ? element.evenRowColor || '#ffffff'
                                 : element.oddRowColor || '#f8f9fa';
                        } else {
                           cellBgColor = element.evenRowColor || '#ffffff';
                        }

                        const [cellBgR, cellBgG, cellBgB] = hexToRgb(cellBgColor);
                        doc.setFillColor(cellBgR, cellBgG, cellBgB);
                        doc.rect(currentX, currentY, fieldWidth, rowHeight, 'F');

                        // Draw cell border
                        if (element.showBorders) {
                           doc.setDrawColor(0, 0, 0);
                           doc.setLineWidth(1);
                           doc.rect(currentX, currentY, fieldWidth, rowHeight, 'S');
                        }

                        // Add cell text
                        const [cellTextR, cellTextG, cellTextB] = hexToRgb(field.color || '#000000');
                        doc.setTextColor(cellTextR, cellTextG, cellTextB);

                        const cellValue = row[field.id] || field.placeholder || '';
                        const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                        // Handle text alignment
                        let textX = currentX + (field.padding || 5);
                        let textOptions = {};

                        if (field.alignment === 'center') {
                           textX = currentX + fieldWidth / 2;
                           textOptions.align = 'center';
                        } else if (field.alignment === 'right') {
                           textX = currentX + fieldWidth - (field.padding || 5);
                           textOptions.align = 'right';
                        }

                        const textY = currentY + rowHeight / 2 + (field.fontSize || 10) / 3;

                        // Handle multi-line text
                        const lines = textValue.split('\n');
                        if (lines.length > 1) {
                           const lineHeight = (field.fontSize || 10) * 1.2;
                           const startY = currentY + (field.padding || 5) + (field.fontSize || 10);

                           lines.forEach((line, lineIndex) => {
                              const lineY = startY + lineIndex * lineHeight;
                              if (lineY < currentY + rowHeight - 5) {
                                 // Ensure text fits in cell
                                 doc.text(line, textX, lineY, textOptions);
                              }
                           });
                        } else {
                           doc.text(textValue, textX, textY, textOptions);
                        }

                        currentX += fieldWidth;
                     });

                     currentY += rowHeight;
                  });

                  // Add page footer with pagination info
                  if (totalPages > 1) {
                     doc.setFontSize(8);
                     doc.setTextColor(128, 128, 128);
                     doc.text(
                        `Table Page ${pageIndex + 1} of ${totalPages} (Rows ${startRowIndex + 1}-${endRowIndex} of ${allRows.length
                        })`,
                        x,
                        pageHeight - 30,
                     );
                  }

                  // Draw outer table border for better definition
                  if (element.showBorders) {
                     doc.setDrawColor(0, 0, 0);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, (pageRows.length + 1) * rowHeight + headerHeight - rowHeight, 'S');
                  }
               }

               // Set isFirstPage to false after first table
               isFirstPage = false;
            } else if (element.type === 'line') {
               // Handle line elements
               const [lineR, lineG, lineB] = hexToRgb(element.color || '#000000');
               doc.setDrawColor(lineR, lineG, lineB);
               doc.setLineWidth(element.thickness || element.height || 1);

               if (element.rotation) {
                  // For rotated lines, we need to calculate the end points
                  const radians = (element.rotation * Math.PI) / 180;

                  // Adjust starting point for vertical lines (90 degrees)
                  let startX = x;
                  let startY = y;

                  if (Math.abs(element.rotation) === 90) {
                     // For vertical lines, start from width/2 offset
                     startX = x + element.width / 2;
                  }

                  const endX = startX + element.width * Math.cos(radians);
                  const endY = startY + element.width * Math.sin(radians);
                  doc.line(startX, startY, endX, endY);
               } else {
                  // Horizontal line
                  doc.line(x, y + element.height / 2, x + element.width, y + element.height / 2);
               }
            } else {
               // Handle text elements with enhanced styling

               // Draw background if specified
               if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                  const [textBgR, textBgG, textBgB] = hexToRgb(element.backgroundColor);
                  doc.setFillColor(textBgR, textBgG, textBgB);
                  doc.rect(x, y, element.width, element.height, 'F');
               }

               // Draw border if specified
               if (element.borderWidth > 0) {
                  const [textBorderR, textBorderG, textBorderB] = hexToRgb(element.borderColor || '#000000');
                  doc.setDrawColor(textBorderR, textBorderG, textBorderB);
                  doc.setLineWidth(element.borderWidth);

                  // Handle different border styles
                  if (element.borderStyle === 'dashed') {
                     doc.setLineDash([3, 3]);
                  } else if (element.borderStyle === 'dotted') {
                     doc.setLineDash([1, 1]);
                  } else {
                     doc.setLineDash([]);
                  }

                  // Draw border with border radius if specified
                  if (element.borderRadius > 0) {
                     doc.roundedRect(
                        x,
                        y,
                        element.width,
                        element.height,
                        element.borderRadius,
                        element.borderRadius,
                        'S',
                     );
                  } else {
                     doc.rect(x, y, element.width, element.height, 'S');
                  }
               }

               // Set text properties with enhanced font handling
               doc.setFontSize(fontSize);

               // Set font family and style
               if (element.fontFamily) {
                  try {
                     doc.setFont(element.fontFamily, element.fontWeight || 'normal');
                  } catch (fontError) {
                     console.warn('Font not available, using default:', element.fontFamily);
                     doc.setFont(undefined, element.fontWeight || 'normal');
                  }
               } else {
                  doc.setFont(undefined, element.fontWeight || 'normal');
               }

               // Apply font style (italic, oblique)
               if (element.fontStyle && element.fontStyle !== 'normal') {
                  try {
                     doc.setFont(undefined, element.fontWeight || 'normal', element.fontStyle);
                  } catch (styleError) {
                     console.warn('Font style not available:', element.fontStyle);
                  }
               }

               const [textR, textG, textB] = hexToRgb(element.color || '#000000');
               doc.setTextColor(textR, textG, textB);

               const lines = element.content.split('\n');
               const lineHeight = element.lineHeight || 1.2;
               const actualLineHeight = fontSize * lineHeight;

               lines.forEach((line, index) => {
                  let textX = x + (element.padding || 0);
                  let textOptions = {};

                  const fontFamily = element.fontFamily || "arial";
                  const fontStyle = element.fontStyle || "normal";
                  doc.setFont(fontFamily, fontStyle);
                  doc.setFontSize(fontSize);

                  console.log("line", line, fontFamily);

                  // Apply text transform
                  let displayText = line;
                  if (element.textTransform === 'uppercase') {
                     displayText = line.toUpperCase();
                  } else if (element.textTransform === 'lowercase') {
                     displayText = line.toLowerCase();
                  } else if (element.textTransform === 'capitalize') {
                     displayText = line.charAt(0).toUpperCase() + line.slice(1);
                  }

                  // Handle text alignment
                  if (element.textAlign === 'center') {
                     textX = x + element.width / 2;
                     textOptions.align = 'center';
                  } else if (element.textAlign === 'right') {
                     textX = x + element.width - (element.padding || 0);
                     textOptions.align = 'right';
                  }

                  // Apply letter spacing (approximate)
                  if (element.letterSpacing && element.letterSpacing !== 0) {
                     textOptions.charSpace = element.letterSpacing;
                  }

                  // Handle text decoration (underline, strikethrough)
                  if (element.textDecoration === 'underline') {
                     textOptions.underline = true;
                  } else if (element.textDecoration === 'line-through') {
                     textOptions.strikethrough = true;
                  }

                  const textY = y + (element.padding || 0) + index * actualLineHeight + fontSize;
                  doc.text(displayText, textX, textY, textOptions);
               });
            }
         }

         doc.save('invoice-format.pdf');
         toast({
            title: 'PDF Generated',
            description: 'Invoice format has been exported successfully!',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         console.error('PDF generation failed:', error);
         toast({
            title: 'Export Failed',
            description: 'Failed to generate PDF. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsGenerating(false);
      }
   };

   //working Enhanced helper function to convert hex color to RGB
   const hexToRgb = (hex) => {
      if (!hex) return [0, 0, 0];

      // Handle named colors
      const namedColors = {
         transparent: [255, 255, 255],
         black: [0, 0, 0],
         white: [255, 255, 255],
         red: [255, 0, 0],
         green: [0, 255, 0],
         blue: [0, 0, 255],
         gray: [128, 128, 128],
         lightgray: [211, 211, 211],
         darkgray: [169, 169, 169],
      };

      if (namedColors[hex.toLowerCase()]) {
         return namedColors[hex.toLowerCase()];
      }

      // Remove # if present
      hex = hex.replace('#', '');

      // Handle 3-digit hex
      if (hex.length === 3) {
         hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      // Handle invalid hex
      if (hex.length !== 6) {
         return [0, 0, 0];
      }

      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Return valid RGB values
      return [isNaN(r) ? 0 : r, isNaN(g) ? 0 : g, isNaN(b) ? 0 : b];
   };

   const handleElementSelect = (element) => {
      setSelectedElement(element);
   };

   const TableRowManagement = ({ element }) => {
      const rows = element.tableData || [];

      return (
         <VStack spacing={4} align="stretch">
            <HStack justify="space-between">
               <Heading size="sm">Table Rows ({rows.length})</Heading>
               <Button
                  size="sm"
                  colorScheme="blue"
                  leftIcon={<Plus size={14} />}
                  onClick={() => addTableRow(element.id)}
                  isDisabled={rows.length >= (element.maxRows || 10)}>
                  Add Row
               </Button>
            </HStack>

            <HStack justify="space-between">
               <Text fontSize="sm">Show Add Button</Text>
               <Checkbox
                  isChecked={element.showAddButton}
                  onChange={(e) => updateElement(element.id, { showAddButton: e.target.checked })}
                  colorScheme="blue"
               />
            </HStack>

            <HStack justify="space-between">
               <Text fontSize="sm">Show Delete Button</Text>
               <Checkbox
                  isChecked={element.showDeleteButton}
                  onChange={(e) => updateElement(element.id, { showDeleteButton: e.target.checked })}
                  colorScheme="blue"
               />
            </HStack>

            <Divider />

            <VStack spacing={2} align="stretch" maxH="300px" overflowY="auto">
               {rows.map((row, index) => (
                  <Box key={row.id} p={2} border="1px solid" borderColor="gray.200" borderRadius="md">
                     <HStack justify="space-between" mb={2}>
                        <Text fontSize="sm" fontWeight="medium">
                           Row {index + 1}
                        </Text>
                        <HStack>
                           <IconButton
                              size="xs"
                              icon={<Copy size={12} />}
                              onClick={() => duplicateTableRow(element.id, row.id)}
                              colorScheme="blue"
                              title="Duplicate Row"
                           />
                           <IconButton
                              size="xs"
                              icon={<Trash2 size={12} />}
                              onClick={() => deleteTableRow(element.id, row.id)}
                              colorScheme="red"
                              title="Delete Row"
                              isDisabled={rows.length <= 1}
                           />
                        </HStack>
                     </HStack>

                     <VStack spacing={2} align="stretch">
                        {element.tableFields.map((field) => (
                           <FormControl key={field.id}>
                              <FormLabel fontSize="xs">{field.label}</FormLabel>
                              <Input
                                 size="xs"
                                 value={row[field.id] || ''}
                                 onChange={(e) => updateTableRowData(element.id, row.id, field.id, e.target.value)}
                                 placeholder={field.placeholder}
                                 type={field.type === 'number' || field.type === 'currency' ? 'number' : 'text'}
                              />
                           </FormControl>
                        ))}
                     </VStack>
                  </Box>
               ))}
            </VStack>
         </VStack>
      );
   };

   const handleQuerySave = (query) => {
      setQueryText(query);

      const formdata = {
         id: parseInt(params.id),
         query,
      };

      dispatch(updatePrintFormat(formdata));

      setTimeout(() => {
         onQueryClose();
      }, 1000);
   };

   const handleSave = async () => {
      setIsGenerating(true);
      try {
         if (url.includes(`/edit/${id}`)) {
            button = 'Save';
            const formdata = {
               id: parseInt(params.id),
               html: JSON.stringify({
                  pageSize: elements.pageSize,
                  customWidth: elements.customWidth,
                  customHeight: elements.customHeight,
                  customUnit: elements.customUnit,
                  orientation: elements.orientation,
                  elements: elements.elements,
               }),
               // html: JSON.stringify(elements),
            };
            dispatch(updatePrintFormat(formdata));
            dispatch({ type: CLEAR_ONE_PRINT, payload: null, single: null });
         } else if (url.includes(`/copy/${id}`)) {
            const formdata = {
               id: parseInt(params.id),
               html: JSON.stringify({
                  pageSize: elements.pageSize,
                  elements: elements.elements,
               }),
               query: singleEntityPrintQuery,
               Name: singleEntityPrintName,
               // html: JSON.stringify(elements),
            };

            dispatch(addPrintFormat(formdata));
         }
         // const formdata = {
         //    id: parseInt(params.id),
         //    html: JSON.stringify({
         //       pageSize: elements.pageSize,
         //       elements: elements.elements,
         //    }),
         //    // html: JSON.stringify(elements),
         // };

         // dispatch(updatePrintFormat(formdata));

         toast({
            title: 'Save Invoice Format',
            description: 'Invoice format has been exported successfully!',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         console.error('PDF generation failed:', error);
         toast({
            title: 'Export Failed',
            description: 'Failed to generate PDF. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsGenerating(false);
      }
   };

   const renderTableElement = (element, isPreview = false) => {
      const fields = element.tableFields || [];
      const rows = element.tableData || [];
      const totalWidth = element.width * (isPreview ? 1 : zoom);

      // Helper function to get border styles based on showBorders and showColumnLines
      const getBorderStyles = (isHeader = false, isLastRow = false, fieldIndex = 0, totalFields = 0) => {
         let borderStyles = {};

         if (element.showBorders) {
            // Original behavior: show all borders
            borderStyles = {
               border: `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`,
            };
         }

         if (element.showColumnLines) {
            // New feature: show vertical column lines + header top/bottom + last row bottom
            borderStyles = {
               ...borderStyles,
               borderTop: 'none',
               borderBottom: 'none',
               borderLeft: 'none',
               borderRight: 'none',
            };

            // Vertical borders for all columns
            if (fieldIndex === 0) {
               // First column gets left border
               borderStyles.borderLeft = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'
                  }`;
            }
            // All columns get right border (creates vertical lines between columns)
            borderStyles.borderRight = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`;

            // Header gets top and bottom border
            if (isHeader) {
               borderStyles.borderTop = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`;
               borderStyles.borderBottom = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'
                  }`;
            }

            // Only last row gets bottom border
            if (isLastRow) {
               borderStyles.borderBottom = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'
                  }`;
            }

            // If both showBorders and showColumnLines are true, maintain outer table border
            if (element.showBorders) {
               // The table container will handle the outer border
            }
         }

         if (!element.showBorders && !element.showColumnLines) {
            borderStyles = { border: 'none' };
         }

         return borderStyles;
      };

      return (
         <TableContainer
            width={totalWidth}
            height={element.height * (isPreview ? 1 : zoom)}
            border={
               element.showBorders
                  ? `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`
                  : 'none'
            }>
            <Table variant="simple" size="sm">
               <Thead>
                  <Tr>
                     {fields.map((field, fieldIndex) => (
                        <Th
                           key={field.id}
                           width={`${field.width}%`}
                           textAlign={field.alignment}
                           fontFamily={field.fontFamily || element.fontFamily || "Arial"}
                           fontSize={`${element.headerStyle.fontSize * (isPreview ? 1 : zoom)}px`}
                           fontWeight={element.headerStyle.fontWeight}
                           color={element.headerStyle.color}
                           backgroundColor={element.headerStyle.backgroundColor}
                           padding={`${field.padding}px`}
                           {...getBorderStyles(true)}>
                           {field.label}
                        </Th>
                     ))}
                  </Tr>
               </Thead>
               <Tbody>
                  {rows.map((row, rowIndex) => {
                     const isLastRow = rowIndex === rows.length - 1;

                     return (
                        <Tr
                           key={row.id}
                           backgroundColor={
                              element.alternateRowColors
                                 ? rowIndex % 2 === 0
                                    ? element.evenRowColor
                                    : element.oddRowColor
                                 : element.evenRowColor
                           }>
                           {fields.map((field, fieldIndex) => (
                              <Td
                                 key={field.id}
                                 textAlign={field.alignment}
                                 fontSize={`${field.fontSize * (isPreview ? 1 : zoom)}px`}
                                 fontWeight={field.fontWeight}
                                 fontFamily={field.fontFamily || element.fontFamily || "Arial"}
                                 color={field.color}
                                 backgroundColor={field.backgroundColor}
                                 padding={`${field.padding}px`}
                                 {...getBorderStyles(false, isLastRow, fieldIndex, fields.length)}>
                                 {isPreview ? (
                                    <Text>{row[field.id] || field.placeholder}</Text>
                                 ) : (
                                    <Input
                                       value={row[field.id] || ''}
                                       onChange={(e) =>
                                          updateTableRowData(element.id, row.id, field.id, e.target.value)
                                       }
                                       placeholder={field.placeholder}
                                       size="sm"
                                       variant="unstyled"
                                       textAlign={field.alignment}
                                       fontSize={`${field.fontSize * zoom}px`}
                                       fontWeight={field.fontWeight}
                                       color={field.color}
                                       type={field.type === 'number' || field.type === 'currency' ? 'number' : 'text'}
                                       step={field.type === 'currency' ? '0.01' : '1'}
                                    />
                                 )}
                              </Td>
                           ))}
                           {!isPreview && element.showDeleteButton && (
                              <Td textAlign="center" width="60px" {...getBorderStyles(false)}>
                                 <HStack spacing={1}>
                                    <IconButton
                                       size="xs"
                                       icon={<Copy size={12} />}
                                       onClick={() => duplicateTableRow(element.id, row.id)}
                                       colorScheme="blue"
                                       variant="ghost"
                                       title="Duplicate Row"
                                    />
                                    <IconButton
                                       size="xs"
                                       icon={<Trash2 size={12} />}
                                       onClick={() => deleteTableRow(element.id, row.id)}
                                       colorScheme="red"
                                       variant="ghost"
                                       title="Delete Row"
                                       isDisabled={rows.length <= 1}
                                    />
                                 </HStack>
                              </Td>
                           )}
                        </Tr>
                     );
                  })}
               </Tbody>
            </Table>

            {!isPreview && element.showAddButton && rows.length < element.maxRows && (
               <Button
                  size="sm"
                  leftIcon={<Plus size={14} />}
                  onClick={() => addTableRow(element.id)}
                  colorScheme="blue"
                  variant="outline"
                  width="100%"
                  mt={2}>
                  Add Row
               </Button>
            )}
         </TableContainer>
      );
   };

   const renderElement = (element, isPreview = false) => {
      const isSelected = !isPreview && selectedElement && selectedElement.id === element.id;

      // Special handling for image elements
      if (element.type === 'image') {
         const imageStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid #E5E7EB',
            backgroundColor: element.backgroundColor || '#F9FAFB',
            borderRadius: element.borderRadius || 0,
            opacity: element.opacity || 1,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
         };

         return (
            <Box
               key={element.id}
               style={imageStyle}
               onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
               userSelect="none"
               position="relative">
               {element.src ? (
                  <img
                     src={element.src}
                     alt={element.alt || 'Image'}
                     style={{
                        width: '100%',
                        height: '100%',
                        objectFit: element.objectFit || 'contain',
                        borderRadius: element.borderRadius || 0,
                     }}
                  />
               ) : (
                  <Box
                     w="100%"
                     h="100%"
                     display="flex"
                     flexDirection="column"
                     alignItems="center"
                     justifyContent="center"
                     color="#6B7280"
                     fontSize={isPreview ? '12px' : `${12 * zoom}px`}
                     textAlign="center"
                     p={2}>
                     <Image size={24} style={{ marginBottom: 8 }} />
                     <Text fontSize="xs">{isPreview ? 'No Image' : element.placeholder || 'Click to upload'}</Text>
                  </Box>
               )}

               {/* Upload overlay for edit mode */}
               {!isPreview && !element.src && (
                  <Input
                     type="file"
                     accept="image/*"
                     position="absolute"
                     top="0"
                     left="0"
                     width="100%"
                     height="100%"
                     opacity="0"
                     cursor="pointer"
                     onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                           handleImageUpload(element, file);
                        }
                     }}
                  />
               )}

               {isSelected && (
                  <HStack position="absolute" top="-4px" right="-4px" spacing={1}>
                     <IconButton
                        size="xs"
                        colorScheme="blue"
                        borderRadius="full"
                        icon={<Copy size={12} />}
                        onClick={(e) => {
                           e.stopPropagation();
                           copyElement(element);
                        }}
                        title="Copy Element"
                     />
                     <IconButton
                        size="xs"
                        colorScheme="red"
                        borderRadius="full"
                        icon={<Trash2 size={12} />}
                        onClick={async (e) => {
                           e.stopPropagation();

                           const result = await Swal.fire({
                              title: 'Are you sure?',
                              text: "You won't be able to revert this!",
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: 'Yes, delete it!',
                           });

                           if (result.isConfirmed) {
                              try {
                                 await deleteElement(element.id);

                                 Swal.fire({
                                    title: 'Deleted!',
                                    text: 'Your element has been deleted.',
                                    icon: 'success',
                                 });
                              } catch (error) {
                                 Swal.fire({
                                    title: 'Error!',
                                    text: 'Failed to delete the element.',
                                    icon: 'error',
                                 });
                              }
                           }
                        }}
                        // onClick={(e) => {
                        //    e.stopPropagation();
                        //    deleteElement(element.id);
                        // }}
                        title="Delete Element"
                     />
                  </HStack>
                  // <IconButton
                  //    position="absolute"
                  //    top="-4px"
                  //    right="-4px"
                  //    size="xs"
                  //    colorScheme="red"
                  //    borderRadius="full"
                  //    icon={<Trash2 size={12} />}
                  //    onClick={(e) => {
                  //       e.stopPropagation();
                  //       deleteElement(element.id);
                  //    }}
                  // />
               )}
            </Box>
         );
      }

      if (element.type === 'barcode') {
         const barcodeStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid #E5E7EB',
            backgroundColor: element.backgroundColor || '#FFFFFF',
            borderRadius: element.borderRadius || 0,
            opacity: element.opacity || 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'monospace',
         };

         // Generate simple barcode visualization (dummy bars)
         const generateBarcodePattern = (value) => {
            const bars = [];
            const barcodeValue = value || element.barcodeValue || '123456789012';

            // Create a simple pattern based on the barcode value
            for (let i = 0; i < barcodeValue.length; i++) {
               const digit = parseInt(barcodeValue[i]) || 0;
               // Create varying bar widths based on digit value
               for (let j = 0; j < 8; j++) {
                  const isBar = (digit + j) % 2 === 0;
                  const width = ((digit % 3) + 1) * (element.barWidth || 2);
                  bars.push({
                     width: `${width}px`,
                     height: `${element.barHeight || 40}px`,
                     backgroundColor: isBar ? element.foregroundColor || '#000000' : 'transparent',
                     marginRight: '1px',
                  });
               }
            }
            return bars.slice(0, 95); // Limit number of bars
         };

         const barcodePattern = generateBarcodePattern(element.content);

         return (
            <Box
               key={element.id}
               style={barcodeStyle}
               onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
               userSelect="none"
               position="relative">
               {/* Barcode bars */}
               <Box
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="center"
                  height={`${element.barHeight || 40}px`}
                  mb={element.showText ? 1 : 0}>
                  {barcodePattern.map((bar, index) => (
                     <Box key={index} style={bar} />
                  ))}
               </Box>

               {/* Barcode text */}
               {element.showText && (
                  <Text
                     fontSize={`${(element.fontSize || 10) * (isPreview ? 1 : zoom)}px`}
                     color={element.foregroundColor || '#000000'}
                     textAlign="center"
                     fontFamily="monospace"
                     mt={element.textMargin || 2}>
                     {element.content || element.barcodeValue || '123456789012'}
                  </Text>
               )}

               {/* Selection controls */}
               {isSelected && (
                  <HStack position="absolute" top="-4px" right="-4px" spacing={1}>
                     <IconButton
                        size="xs"
                        colorScheme="blue"
                        borderRadius="full"
                        icon={<Copy size={12} />}
                        onClick={(e) => {
                           e.stopPropagation();
                           copyElement(element);
                        }}
                        title="Copy Element"
                     />
                     <IconButton
                        size="xs"
                        colorScheme="red"
                        borderRadius="full"
                        icon={<Trash2 size={12} />}
                        onClick={async (e) => {
                           e.stopPropagation();

                           const result = await Swal.fire({
                              title: 'Are you sure?',
                              text: "You won't be able to revert this!",
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: 'Yes, delete it!',
                           });

                           if (result.isConfirmed) {
                              try {
                                 await deleteElement(element.id);

                                 Swal.fire({
                                    title: 'Deleted!',
                                    text: 'Your element has been deleted.',
                                    icon: 'success',
                                 });
                              } catch (error) {
                                 Swal.fire({
                                    title: 'Error!',
                                    text: 'Failed to delete the element.',
                                    icon: 'error',
                                 });
                              }
                           }
                        }}
                        // onClick={(e) => {
                        //    e.stopPropagation();
                        //    deleteElement(element.id);
                        // }}
                        title="Delete Element"
                     />
                  </HStack>
               )}
            </Box>
         );
      }

      // Special handling for line elements
      if (element.type === 'line') {
         const lineStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid transparent',
            backgroundColor: isSelected ? 'rgba(59, 130, 246, 0.1)' : element.backgroundColor || 'transparent',
            minHeight: isPreview ? element.height : Math.max(element.height, 10),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
         };

         return (
            <Box
               key={element.id}
               style={lineStyle}
               onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
               userSelect="none"
               position="relative">
               <Box
                  w="100%"
                  h={`${element.thickness || element.height}px`}
                  bg={element.color || '#000000'}
                  style={{
                     transform: element.rotation ? `rotate(${element.rotation}deg)` : 'none',
                     transformOrigin: 'center center',
                  }}
               />
               {isSelected && (
                  <>
                     <IconButton
                        position="absolute"
                        top="-4px"
                        right="-4px"
                        size="xs"
                        colorScheme="red"
                        borderRadius="full"
                        icon={<Copy size={12} />}
                        onClick={(e) => {
                           e.stopPropagation();
                           copyElement(element);
                        }}
                     />
                     <IconButton
                        position="absolute"
                        top="-4px"
                        right="-4px"
                        size="xs"
                        colorScheme="red"
                        borderRadius="full"
                        icon={<Trash2 size={12} />}
                        onClick={async (e) => {
                           e.stopPropagation();

                           const result = await Swal.fire({
                              title: 'Are you sure?',
                              text: "You won't be able to revert this!",
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: 'Yes, delete it!',
                           });

                           if (result.isConfirmed) {
                              try {
                                 await deleteElement(element.id);

                                 Swal.fire({
                                    title: 'Deleted!',
                                    text: 'Your element has been deleted.',
                                    icon: 'success',
                                 });
                              } catch (error) {
                                 Swal.fire({
                                    title: 'Error!',
                                    text: 'Failed to delete the element.',
                                    icon: 'error',
                                 });
                              }
                           }
                        }}
                     // onClick={(e) => {
                     //    e.stopPropagation();
                     //    deleteElement(element.id);
                     // }}
                     />
                  </>
               )}
            </Box>
         );
      }

      // FIXED: Determine proper whiteSpace and wordWrap behavior
      const getTextWrapStyle = () => {
         // If wordWrap is set to 'break-word', allow wrapping
         if (element.wordWrap === 'break-word') {
            return {
               whiteSpace: 'pre-wrap', // Allow wrapping and preserve line breaks
               wordWrap: 'break-word',
               wordBreak: 'break-word', // Additional CSS property for better wrapping
               overflow: 'visible',
            };
         }

         // For specific element types that should wrap by default
         if (element.type === 'client' || element.type === 'notes') {
            return {
               whiteSpace: 'pre-wrap',
               wordWrap: 'normal',
               overflow: 'visible',
            };
         }

         // For custom whiteSpace settings
         if (element.whiteSpace === 'pre-wrap') {
            return {
               whiteSpace: 'pre-wrap',
               wordWrap: element.wordWrap || 'normal',
               overflow: 'visible',
            };
         }

         // Default behavior - no wrapping
         return {
            whiteSpace: element.whiteSpace || 'nowrap',
            wordWrap: element.wordWrap || 'normal',
            overflow: 'hidden',
         };
      };
      const getVerticalAlignStyle = () => {
         const verticalAlign = element.verticalAlign || 'top';

         switch (verticalAlign) {
            case 'middle':
               return {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                           ? 'flex-end'
                           : 'flex-start',
               };
            case 'bottom':
               return {
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                           ? 'flex-end'
                           : 'flex-start',
               };
            case 'top':
            default:
               return {
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                           ? 'flex-end'
                           : 'flex-start',
               };
         }
      };
      const textWrapStyle = getTextWrapStyle();
      const verticalAlignStyle = getVerticalAlignStyle();

      // Regular element styling for other elements
      const elementStyle = {
         position: 'absolute',
         left: element.x * (isPreview ? 1 : zoom),
         top: element.y * (isPreview ? 1 : zoom),
         width: element.width * (isPreview ? 1 : zoom),
         height: element.height * (isPreview ? 1 : zoom),
         fontSize: element.fontSize * (isPreview ? 1 : zoom),
         fontWeight: element.fontWeight || 'normal',
         fontStyle: element.fontStyle || 'normal',
         fontFamily: element.fontFamily || 'Arial',
         color: element.color || '#000000',
         textAlign: element.textAlign || 'left',
         textDecoration: element.textDecoration || 'none',
         border: isSelected ? '2px solid #3B82F6' : '1px solid transparent',
         cursor: isPreview ? 'default' : 'move',
         // FIXED: Apply proper text wrapping styles
         ...textWrapStyle,
         ...verticalAlignStyle,
         backgroundColor: element.backgroundColor || 'transparent',
         borderColor: element.borderColor || 'transparent',
         borderWidth: element.borderWidth || 0,
         borderStyle: element.borderStyle || 'solid',
         borderRadius: element.borderRadius || 0,
         padding: element.padding || '4px',
         opacity: element.opacity || 1,
         textTransform: element.textTransform || 'none',
         lineHeight: element.lineHeight || 1.2,
         letterSpacing: `${element.letterSpacing || 0}px`,
         boxShadow: isSelected ? 'inset 0 0 0 2px rgba(59, 130, 246, 0.1)' : 'none',
      };

      return (
         <Box
            key={element.id}
            style={elementStyle}
            onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
            userSelect="none"
            position="relative">
            {element.type === 'table' ? renderTableElement(element, isPreview) : <Box>{element.content}</Box>}
            {isSelected && (
               <>
                  <IconButton
                     position="absolute"
                     top="0px"
                     right="25px"
                     size="xs"
                     colorScheme="blue"
                     borderRadius="full"
                     icon={<Copy size={12} />}
                     onClick={(e) => {
                        e.stopPropagation();
                        copyElement(element);
                     }}
                  />
                  <IconButton
                     position="absolute"
                     top="0px"
                     right="-4px"
                     size="xs"
                     colorScheme="red"
                     borderRadius="full"
                     icon={<Trash2 size={12} />}
                     onClick={async (e) => {
                        e.stopPropagation();

                        const result = await Swal.fire({
                           title: 'Are you sure?',
                           text: "You won't be able to revert this!",
                           icon: 'warning',
                           showCancelButton: true,
                           confirmButtonColor: '#3085d6',
                           cancelButtonColor: '#d33',
                           confirmButtonText: 'Yes, delete it!',
                        });

                        if (result.isConfirmed) {
                           try {
                              await deleteElement(element.id);

                              Swal.fire({
                                 title: 'Deleted!',
                                 text: 'Your element has been deleted.',
                                 icon: 'success',
                              });
                           } catch (error) {
                              Swal.fire({
                                 title: 'Error!',
                                 text: 'Failed to delete the element.',
                                 icon: 'error',
                              });
                           }
                        }
                     }}
                  />
               </>
            )}
         </Box>
      );
   };

   const renderImageProperties = (element) => {
      return (
         <>
            <FormControl>
               <FormLabel>Image Upload</FormLabel>
               <Input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                     const file = e.target.files[0];
                     if (file) {
                        handleImageUpload(element, file);
                     }
                  }}
               />
            </FormControl>

            <FormControl>
               <FormLabel>Alt Text</FormLabel>
               <Input
                  value={element.alt || ''}
                  onChange={(e) => updateElement(element.id, 'alt', e.target.value)}
                  placeholder="Image description"
               />
            </FormControl>

            <FormControl>
               <FormLabel>Object Fit</FormLabel>
               <Select
                  value={element.objectFit || 'contain'}
                  onChange={(e) => updateElement(element.id, 'objectFit', e.target.value)}>
                  <option value="contain">Contain</option>
                  <option value="cover">Cover</option>
                  <option value="fill">Fill</option>
                  <option value="none">None</option>
                  <option value="scale-down">Scale Down</option>
               </Select>
            </FormControl>

            <FormControl>
               <FormLabel>Border Radius</FormLabel>
               <NumberInput
                  value={element.borderRadius || 0}
                  onChange={(value) => updateElement(element.id, 'borderRadius', parseInt(value))}
                  min={0}
                  max={50}>
                  <NumberInputField />
                  <NumberInputStepper>
                     <NumberIncrementStepper />
                     <NumberDecrementStepper />
                  </NumberInputStepper>
               </NumberInput>
            </FormControl>

            <FormControl>
               <FormLabel>Opacity</FormLabel>
               <NumberInput
                  value={element.opacity || 1}
                  onChange={(value) => updateElement(element.id, 'opacity', parseFloat(value))}
                  min={0}
                  max={1}
                  step={0.1}>
                  <NumberInputField />
                  <NumberInputStepper>
                     <NumberIncrementStepper />
                     <NumberDecrementStepper />
                  </NumberInputStepper>
               </NumberInput>
            </FormControl>

            {element.src && (
               <FormControl>
                  <FormLabel>Actions</FormLabel>
                  <Button size="sm" colorScheme="red" onClick={() => updateElement(element.id, 'src', '')}>
                     Remove Image
                  </Button>
               </FormControl>
            )}
         </>
      );
   };

   const renderBarcodeProperties = (element) => {
      return (
         <>
            <FormControl>
               <FormLabel>Barcode Value</FormLabel>
               <Input
                  value={element.barcodeValue || element.content || ''}
                  onChange={(e) => {
                     updateElement(element.id, 'barcodeValue', e.target.value);
                     updateElement(element.id, 'content', e.target.value);
                  }}
                  placeholder="123456789012"
               />
            </FormControl>

            <FormControl>
               <FormLabel>Barcode Type</FormLabel>
               <Select
                  value={element.barcodeType || 'CODE128'}
                  onChange={(e) => updateElement(element.id, 'barcodeType', e.target.value)}>
                  <option value="CODE128">CODE128</option>
                  <option value="CODE39">CODE39</option>
                  <option value="EAN13">EAN13</option>
                  <option value="UPC">UPC</option>
               </Select>
            </FormControl>

            <FormControl display="flex" alignItems="center">
               <FormLabel mb="0">Show Text</FormLabel>
               <Switch
                  isChecked={element.showText !== false}
                  onChange={(e) => updateElement(element.id, 'showText', e.target.checked)}
               />
            </FormControl>

            <FormControl>
               <FormLabel>Bar Width</FormLabel>
               <NumberInput
                  value={element.barWidth || 2}
                  onChange={(value) => updateElement(element.id, 'barWidth', parseInt(value))}
                  min={1}
                  max={5}>
                  <NumberInputField />
                  <NumberInputStepper>
                     <NumberIncrementStepper />
                     <NumberDecrementStepper />
                  </NumberInputStepper>
               </NumberInput>
            </FormControl>

            <FormControl>
               <FormLabel>Bar Height</FormLabel>
               <NumberInput
                  value={element.barHeight || 40}
                  onChange={(value) => updateElement(element.id, 'barHeight', parseInt(value))}
                  min={20}
                  max={100}>
                  <NumberInputField />
                  <NumberInputStepper>
                     <NumberIncrementStepper />
                     <NumberDecrementStepper />
                  </NumberInputStepper>
               </NumberInput>
            </FormControl>

            <FormControl>
               <FormLabel>Foreground Color</FormLabel>
               <Input
                  type="color"
                  value={element.foregroundColor || '#000000'}
                  onChange={(e) => updateElement(element.id, 'foregroundColor', e.target.value)}
               />
            </FormControl>

            <FormControl>
               <FormLabel>Background Color</FormLabel>
               <Input
                  type="color"
                  value={element.backgroundColor || '#FFFFFF'}
                  onChange={(e) => updateElement(element.id, 'backgroundColor', e.target.value)}
               />
            </FormControl>
         </>
      );
   };

   // Movement Controls Component (to be added to your properties panel)
   const MovementControls = ({
      selectedElement,
      moveElement,
      updateElement,
      elements,
      getPageWidth,
      getPageHeight,
   }) => {
      if (!selectedElement) return null;

      // Helper function to handle alignment with x-y coordinates
      const handleAlignment = (alignment) => {
         if (!selectedElement) return;

         // Get canvas dimensions based on current page configuration
         const canvasWidth = getPageWidth(elements);
         const canvasHeight = getPageHeight(elements);

         let newX = selectedElement.x;
         let newY = selectedElement.y;

         switch (alignment) {
            case 'center':
               newX = (canvasWidth - selectedElement.width) / 2;
               break;
            case 'start':
               newX = 0;
               break;
            case 'end':
               newX = canvasWidth - selectedElement.width;
               break;
            case 'top':
               newY = 0;
               break;
            case 'middle':
               newY = (canvasHeight - selectedElement.height) / 2;
               break;
            case 'bottom':
               newY = canvasHeight - selectedElement.height;
               break;
            default:
               return;
         }

         // Update element position using the existing updateElement function
         updateElement(selectedElement.id, { x: newX, y: newY });
      };

      // Helper function to handle text alignment within the element
      const handleTextAlignment = (textAlign) => {
         if (!selectedElement) return;
         updateElement(selectedElement.id, { textAlign });
      };

      // Helper function to handle vertical text alignment
      const handleVerticalTextAlignment = (verticalAlign) => {
         if (!selectedElement) return;
         updateElement(selectedElement.id, { verticalAlign });
      };

      // Check if selected element supports text alignment
      const supportsTextAlignment =
         selectedElement &&
         (selectedElement.type === 'text' || selectedElement.type === 'client' || selectedElement.type === 'notes');

      return (
         <Box>
            <Text fontWeight="bold" mb={2}>
               Movement Controls
            </Text>
            <VStack spacing={4}>
               {/* Normal Movement Controls */}
               <Box>
                  <Text fontSize="sm" mb={2}>
                     Normal Movement:
                  </Text>
                  <ButtonGroup size="sm" variant="solid" colorScheme="blue">
                     <Button onClick={() => moveElement(selectedElement.id, 'up')} title="Move Up (5px)">
                        <ChevronUp size={16} />
                     </Button>
                     <Button onClick={() => moveElement(selectedElement.id, 'down')} title="Move Down (5px)">
                        <ChevronDown size={16} />
                     </Button>
                     <Button onClick={() => moveElement(selectedElement.id, 'left')} title="Move Left (5px)">
                        <ChevronLeft size={16} />
                     </Button>
                     <Button onClick={() => moveElement(selectedElement.id, 'right')} title="Move Right (5px)">
                        <ChevronRight size={16} />
                     </Button>
                  </ButtonGroup>
               </Box>

               {/* Text Alignment Controls - Only show for text elements */}
               {supportsTextAlignment && (
                  <>
                     <Box>
                        <Text fontSize="sm" mb={2}>
                           Text Alignment:
                        </Text>
                        <ButtonGroup size="sm" variant="outline" colorScheme="orange">
                           <Button
                              onClick={() => handleTextAlignment('left')}
                              title="Align Text Left"
                              variant={selectedElement.textAlign === 'left' ? 'solid' : 'outline'}>
                              <AlignLeft size={16} />
                           </Button>
                           <Button
                              onClick={() => handleTextAlignment('center')}
                              title="Center Text"
                              variant={selectedElement.textAlign === 'center' ? 'solid' : 'outline'}>
                              <AlignCenter size={16} />
                           </Button>
                           <Button
                              onClick={() => handleTextAlignment('right')}
                              title="Align Text Right"
                              variant={selectedElement.textAlign === 'right' ? 'solid' : 'outline'}>
                              <AlignRight size={16} />
                           </Button>
                           <Button
                              onClick={() => handleTextAlignment('justify')}
                              title="Justify Text"
                              variant={selectedElement.textAlign === 'justify' ? 'solid' : 'outline'}>
                              <AlignJustify size={16} />
                           </Button>
                        </ButtonGroup>
                     </Box>
                     <Box>
                        <Text fontSize="xs" mb={1} color="gray.600">
                           Vertical:
                        </Text>
                        <ButtonGroup size="sm" variant="outline" colorScheme="orange">
                           <Button
                              onClick={() => handleVerticalTextAlignment('top')}
                              title="Align Text Top"
                              variant={selectedElement.verticalAlign === 'top' ? 'solid' : 'outline'}>
                              <AlignVerticalJustifyStart size={16} />
                           </Button>
                           <Button
                              onClick={() => handleVerticalTextAlignment('middle')}
                              title="Center Text Vertically"
                              variant={selectedElement.verticalAlign === 'middle' ? 'solid' : 'outline'}>
                              <AlignVerticalJustifyCenter size={16} />
                           </Button>
                           <Button
                              onClick={() => handleVerticalTextAlignment('bottom')}
                              title="Align Text Bottom"
                              variant={selectedElement.verticalAlign === 'bottom' ? 'solid' : 'outline'}>
                              <AlignVerticalJustifyEnd size={16} />
                           </Button>
                           <Button
                              onClick={() => handleVerticalTextAlignment('baseline')}
                              title="Align Text Baseline"
                              variant={selectedElement.verticalAlign === 'baseline' ? 'solid' : 'outline'}>
                              <Minus size={16} />
                           </Button>
                        </ButtonGroup>
                     </Box>
                  </>
               )}

               {/* Horizontal Alignment Controls */}
               <Box>
                  <Text fontSize="sm" mb={2}>
                     Horizontal Alignment:
                  </Text>
                  <ButtonGroup size="sm" variant="outline" colorScheme="green">
                     <Button onClick={() => handleAlignment('start')} title="Align to Start (Left)">
                        <AlignLeft size={16} />
                     </Button>
                     <Button onClick={() => handleAlignment('center')} title="Center Horizontally">
                        <AlignCenter size={16} />
                     </Button>
                     <Button onClick={() => handleAlignment('end')} title="Align to End (Right)">
                        <AlignRight size={16} />
                     </Button>
                  </ButtonGroup>
               </Box>

               {/* Vertical Alignment Controls */}
               <Box>
                  <Text fontSize="sm" mb={2}>
                     Vertical Alignment:
                  </Text>
                  <ButtonGroup size="sm" variant="outline" colorScheme="purple">
                     <Button onClick={() => handleAlignment('top')} title="Align to Top">
                        <AlignVerticalJustifyStart size={16} />
                     </Button>
                     <Button onClick={() => handleAlignment('middle')} title="Center Vertically">
                        <AlignVerticalJustifyCenter size={16} />
                     </Button>
                     <Button onClick={() => handleAlignment('bottom')} title="Align to Bottom">
                        <AlignVerticalJustifyEnd size={16} />
                     </Button>
                  </ButtonGroup>
               </Box>

               {/* Position Display */}
               <HStack spacing={4} mt={2}>
                  <Text fontSize="sm">X: {selectedElement.x}</Text>
                  <Text fontSize="sm">Y: {selectedElement.y}</Text>
                  {supportsTextAlignment && <Text fontSize="sm">Text: {selectedElement.textAlign || 'left'}</Text>}
               </HStack>
            </VStack>
         </Box>
      );
   };

   // Enhanced Position Input Component
   const PositionInputs = ({ selectedElement, updateElement }) => {
      if (!selectedElement) return null;

      const handlePositionChange = (axis, value) => {
         const numValue = parseFloat(value) || 0;
         updateElement(selectedElement.id, axis, Math.max(0, numValue));
      };

      return (
         <VStack spacing={2}>
            <HStack spacing={2}>
               <Text fontSize="sm" minWidth="20px">
                  X:
               </Text>
               <NumberInput
                  size="sm"
                  value={selectedElement.x}
                  onChange={(value) => handlePositionChange('x', value)}
                  min={0}
                  step={1}>
                  <NumberInputField />
                  <NumberInputStepper>
                     <NumberIncrementStepper />
                     <NumberDecrementStepper />
                  </NumberInputStepper>
               </NumberInput>
            </HStack>
            <HStack spacing={2}>
               <Text fontSize="sm" minWidth="20px">
                  Y:
               </Text>
               <NumberInput
                  size="sm"
                  value={selectedElement.y}
                  onChange={(value) => handlePositionChange('y', value)}
                  min={0}
                  step={1}>
                  <NumberInputField />
                  <NumberInputStepper>
                     <NumberIncrementStepper />
                     <NumberDecrementStepper />
                  </NumberInputStepper>
               </NumberInput>
            </HStack>
         </VStack>
      );
   };

   const PreviewModal = () => (
      <Modal isOpen={isOpen} onClose={onClose} size="12xl">
         <ModalOverlay />
         <ModalContent maxW="100vw" maxH="100vh">
            <ModalHeader>
               <Flex justify={'space-between'} align={'center'}>
                  <Text>Invoice Preview</Text>
                  <Box>
                     <Button colorScheme="green" mr={3} onClick={handleSave} isLoading={isGenerating}>
                        {button}
                     </Button>
                     <Button colorScheme="blue" mr={10} onClick={generatePDF} isLoading={isGenerating}>
                        Export PDF
                     </Button>
                     {/* <Button onClick={onClose}>Close</Button> */}
                  </Box>
               </Flex>{' '}
            </ModalHeader>

            <ModalCloseButton />
            <ModalBody>
               <Box
                  ref={printRef}
                  width={`${getPageWidth(elements)}px`}
                  height={`${getPageHeight(elements)}px`}
                  // width={`${getPageWidth(elements.pageSize)}px`}
                  // height={`${getPageHeight(elements.pageSize)}px`}
                  bg="white"
                  border="1px solid"
                  borderColor="gray.300"
                  mx="auto"
                  position="relative"
                  overflow="hidden">
                  {elements.elements.map((element) => renderElement(element, true))}
               </Box>
            </ModalBody>
         </ModalContent>
      </Modal>
   );

   if (isLoading) {
      return (
         <Flex justify="center" align="center" minH="100vh" bg={bgColor}>
            <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
         </Flex>
      );
   }

   return (
      <Flex h="100vh" bg={bgColor} overflowY="auto" mt={'2%'}>
         {/* Sidebar */}
         <Box w="400px" bg={cardBg} shadow="lg" mt={5} display="flex" flexDirection="column">
            <Tabs index={activeTab} onChange={setActiveTab} variant="enclosed">
               <TabList>
                  <Tab>
                     <Layout size={16} style={{ marginRight: '8px' }} />
                     Design
                  </Tab>
                  <Tab>
                     <Settings size={16} style={{ marginRight: '8px' }} />
                     Properties
                  </Tab>
               </TabList>
               <TabPanels flex={1} overflowY="hidden">
                  <TabPanel h="full" p={0}>
                     <VStack spacing={6} align="stretch" h="full" overflowY="auto" p={4}>
                        <Box>
                           <Heading size="md" mb={4}>
                              Add Elements
                           </Heading>
                           {copiedElement && (
                              <Button
                                 onClick={pasteElement}
                                 colorScheme="green"
                                 variant="outline"
                                 leftIcon={<Clipboard size={16} />}
                                 size="sm"
                                 mb={5}
                                 w="100%">
                                 Paste Element
                              </Button>
                           )}
                           {selectedElement && (
                              <HStack spacing={2} w="100%" mb={4}>
                                 <Button
                                    onClick={(e) => {
                                       e.stopPropagation();
                                       copyElement(selectedElement);
                                    }}
                                    colorScheme="blue"
                                    variant="outline"
                                    leftIcon={<Copy size={16} />}
                                    size="sm"
                                    flex={1}
                                    _hover={{ bg: 'blue.50' }}>
                                    Copy
                                 </Button>

                                 <Button
                                    onClick={async (e) => {
                                       e.stopPropagation();

                                       const result = await Swal.fire({
                                          title: 'Are you sure?',
                                          text: "You won't be able to revert this!",
                                          icon: 'warning',
                                          showCancelButton: true,
                                          confirmButtonColor: '#3085d6',
                                          cancelButtonColor: '#d33',
                                          confirmButtonText: 'Yes, delete it!',
                                       });

                                       if (result.isConfirmed) {
                                          try {
                                             await deleteElement(selectedElement.id);

                                             Swal.fire({
                                                title: 'Deleted!',
                                                text: 'Your element has been deleted.',
                                                icon: 'success',
                                             });
                                          } catch (error) {
                                             Swal.fire({
                                                title: 'Error!',
                                                text: 'Failed to delete the element.',
                                                icon: 'error',
                                             });
                                          }
                                       }
                                    }}
                                    colorScheme="red"
                                    variant="outline"
                                    leftIcon={<Trash2 size={16} />}
                                    size="sm"
                                    flex={1}
                                    _hover={{ bg: 'red.50' }}>
                                    Delete
                                 </Button>
                              </HStack>
                           )}
                           <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                              {fieldTypes.map((field) => (
                                 <Button
                                    key={field.id}
                                    onClick={() => addElement(field.id, field.orientation)}
                                    variant="outline"
                                    border="2px dashed"
                                    borderColor="gray.300"
                                    _hover={{ borderColor: 'blue.400', bg: 'blue.50' }}
                                    h="auto"
                                    p={3}
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center">
                                    <field.icon
                                       size={20}
                                       color={field.color}
                                       style={{
                                          transform: field.orientation === 'vertical' ? 'rotate(90deg)' : 'none',
                                       }}
                                    />
                                    <Text fontSize="sm" mt={1}>
                                       {field.label}
                                    </Text>
                                 </Button>
                              ))}
                           </Grid>
                           <Button onClick={onQueryOpen}>Edit SQL Query</Button>
                        </Box>
                        <VStack spacing={4} align="stretch">
                           <HStack justify="space-between">
                              <Text fontSize="sm" fontWeight="medium">
                                 Show Grid
                              </Text>
                              <Checkbox
                                 isChecked={showGrid}
                                 onChange={(e) => setShowGrid(e.target.checked)}
                                 colorScheme="blue"
                              />
                           </HStack>
                           <Box>
                              <Text fontSize="sm" fontWeight="medium" mb={2}>
                                 Page Size
                              </Text>
                              <Select
                                 value={elements.pageSize}
                                 onChange={(e) => setElements((prev) => ({ ...prev, pageSize: e.target.value }))}
                                 size="sm">
                                 {Object.entries(PAPER_SIZES).map(([key, size]) => (
                                    <option key={key} value={key}>
                                       {size.label}
                                    </option>
                                 ))}
                              </Select>
                           </Box>
                           <Box>
                              <Text fontSize="sm" fontWeight="medium" mb={2}>
                                 Orientation
                              </Text>
                              <ButtonGroup size="sm" isAttached variant="outline">
                                 <Button
                                    onClick={() => setElements((prev) => ({ ...prev, orientation: 'portrait' }))}
                                    variant={elements.orientation === 'portrait' ? 'solid' : 'outline'}
                                    colorScheme="blue">
                                    Portrait
                                 </Button>
                                 <Button
                                    onClick={() => setElements((prev) => ({ ...prev, orientation: 'landscape' }))}
                                    variant={elements.orientation === 'landscape' ? 'solid' : 'outline'}
                                    colorScheme="blue">
                                    Landscape
                                 </Button>
                              </ButtonGroup>
                           </Box>

                           {elements.pageSize === 'custom' && (
                              <VStack spacing={3}>
                                 <Box>
                                    <Text fontSize="sm" fontWeight="medium" mb={2}>
                                       Unit
                                    </Text>
                                    <Select
                                       value={elements.customUnit || 'mm'}
                                       onChange={(e) => {
                                          const newUnit = e.target.value;
                                          const oldUnit = elements.customUnit || 'mm';

                                          // Convert existing values to new unit
                                          const currentWidthInPixels = convertToPixels(
                                             elements.customWidth || 210,
                                             oldUnit,
                                          );
                                          const currentHeightInPixels = convertToPixels(
                                             elements.customHeight || 297,
                                             oldUnit,
                                          );

                                          const newWidth = convertFromPixels(currentWidthInPixels, newUnit);
                                          const newHeight = convertFromPixels(currentHeightInPixels, newUnit);

                                          setElements((prev) => ({
                                             ...prev,
                                             customUnit: newUnit,
                                             customWidth: newWidth,
                                             customHeight: newHeight,
                                          }));
                                       }}
                                       size="sm">
                                       <option value="mm">Millimeters (mm)</option>
                                       <option value="cm">Centimeters (cm)</option>
                                       <option value="inch">Inches (in)</option>
                                       <option value="px">Pixels (px)</option>
                                    </Select>
                                 </Box>

                                 <Box>
                                    <Text fontSize="sm" fontWeight="medium" mb={2}>
                                       Custom Dimensions ({elements.customUnit || 'mm'})
                                    </Text>
                                    <HStack spacing={3}>
                                       <Box>
                                          <Text fontSize="xs" mb={1}>
                                             Width
                                          </Text>
                                          <Input
                                             type="number"
                                             step="0.1"
                                             value={elements.customWidth || 210}
                                             onChange={(e) =>
                                                setElements((prev) => ({
                                                   ...prev,
                                                   customWidth: parseFloat(e.target.value) || 210,
                                                }))
                                             }
                                             size="sm"
                                             min="1"
                                          />
                                       </Box>
                                       <Box>
                                          <Text fontSize="xs" mb={1}>
                                             Height
                                          </Text>
                                          <Input
                                             type="number"
                                             step="0.1"
                                             value={elements.customHeight || 297}
                                             onChange={(e) =>
                                                setElements((prev) => ({
                                                   ...prev,
                                                   customHeight: parseFloat(e.target.value) || 297,
                                                }))
                                             }
                                             size="sm"
                                             min="1"
                                          />
                                       </Box>
                                    </HStack>
                                 </Box>
                              </VStack>
                           )}

                           <Box bg="gray.50" p={2} borderRadius="md">
                              <Text fontSize="xs" color="gray.600">
                                 Current Size: {getPageWidth(elements)} × {getPageHeight(elements)} px
                                 {elements.pageSize === 'custom' && (
                                    <Text fontSize="xs" color="gray.500" mt={1}>
                                       ({elements.customWidth || 210} × {elements.customHeight || 297}{' '}
                                       {elements.customUnit || 'mm'})
                                    </Text>
                                 )}
                              </Text>
                           </Box>
                           <Box>
                              <Text fontSize="sm" fontWeight="medium" mb={2}>
                                 Zoom: {Math.round(zoom * 100)}%
                              </Text>
                              <Slider
                                 value={zoom}
                                 onChange={(val) => setZoom(val)}
                                 min={0.5}
                                 max={2}
                                 step={0.1}
                                 colorScheme="blue">
                                 <SliderTrack>
                                    <SliderFilledTrack />
                                 </SliderTrack>
                                 <SliderThumb />
                              </Slider>
                           </Box>
                           <MovementControls
                              selectedElement={selectedElement}
                              moveElement={moveElement}
                              updateElement={updateElement}
                              elements={elements}
                              getPageWidth={getPageWidth}
                              getPageHeight={getPageHeight}
                           />
                           <PositionInputs selectedElement={selectedElement} updateElement={updateElement} />
                        </VStack>
                     </VStack>
                  </TabPanel>
                  <TabPanel h="full" p={0}>
                     {selectedElement ? (
                        <VStack spacing={4} align="stretch" h="full" overflowY="auto" p={4}>
                           <Heading size="md">Element Properties</Heading>

                           <FormControl>
                              <FormLabel fontSize="sm">Id</FormLabel>
                              <Textarea
                                 value={selectedElement.id}
                                 onChange={(e) => updateElement(selectedElement.id, { id: e.target.value })}
                                 rows={2}
                                 resize="vertical"
                              />
                           </FormControl>

                           <FormControl>
                              <FormLabel fontSize="sm">Content</FormLabel>
                              <Textarea
                                 value={selectedElement.content}
                                 onChange={(e) => updateElement(selectedElement.id, { content: e.target.value })}
                                 rows={2}
                                 resize="vertical"
                              />
                           </FormControl>

                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">X</FormLabel>
                                 <Input
                                    type="number"
                                    value={selectedElement.x}
                                    onChange={(e) => updateElement(selectedElement.id, { x: parseInt(e.target.value) })}
                                    size="sm"
                                 />
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Y</FormLabel>
                                 <Input
                                    type="number"
                                    value={selectedElement.y}
                                    onChange={(e) => updateElement(selectedElement.id, { y: parseInt(e.target.value) })}
                                    size="sm"
                                 />
                              </FormControl>
                           </HStack>

                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Width</FormLabel>
                                 <Input
                                    type="number"
                                    value={selectedElement.width}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { width: parseInt(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Height</FormLabel>
                                 <Input
                                    type="number"
                                    value={selectedElement.height}
                                    isDisabled={selectedElement.isVertical}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { height: parseInt(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                           </HStack>

                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Font Size</FormLabel>
                                 <Input
                                    type="number"
                                    value={selectedElement.fontSize}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { fontSize: parseInt(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Font Weight</FormLabel>
                                 <Select
                                    value={selectedElement.fontWeight}
                                    onChange={(e) => updateElement(selectedElement.id, { fontWeight: e.target.value })}
                                    size="sm">
                                    <option value="normal">Normal</option>
                                    <option value="bold">Bold</option>
                                    <option value="lighter">Lighter</option>
                                 </Select>
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Font Family</FormLabel>
                                 <Select
                                    value={selectedElement.fontFamily || 'Arial'}
                                    onChange={(e) => updateElement(selectedElement.id, { fontFamily: e.target.value })}
                                    size="sm">
                                    {fontFamilyOptions.map((font) => (
                                       <option key={font} value={font} style={{ fontFamily: font }}>
                                          {font}
                                       </option>
                                    ))}
                                 </Select>
                              </FormControl>
                           </HStack>
                           {/* Font Style and Text Decoration */}
                           <HStack spacing={2}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Font Style</FormLabel>
                                 <Select
                                    value={selectedElement.fontStyle || 'normal'}
                                    onChange={(e) => updateElement(selectedElement.id, { fontStyle: e.target.value })}
                                    size="sm">
                                    {fontStyleOptions.map((style) => (
                                       <option key={style.value} value={style.value}>
                                          {style.label}
                                       </option>
                                    ))}
                                 </Select>
                              </FormControl>

                              <FormControl>
                                 <FormLabel fontSize="sm">Text Decoration</FormLabel>
                                 <Select
                                    value={selectedElement.textDecoration || 'none'}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { textDecoration: e.target.value })
                                    }
                                    size="sm">
                                    {textDecorationOptions.map((decoration) => (
                                       <option key={decoration.value} value={decoration.value}>
                                          {decoration.label}
                                       </option>
                                    ))}
                                 </Select>
                              </FormControl>
                           </HStack>

                           {/* Word Wrap and White Space */}
                           <VStack spacing={3} align="stretch">
                              <Text fontSize="sm" fontWeight="medium">
                                 Text Wrapping
                              </Text>

                              <FormControl>
                                 <FormLabel fontSize="sm">Word Wrap</FormLabel>
                                 <Select
                                    value={selectedElement.wordWrap || 'normal'}
                                    onChange={(e) => updateElement(selectedElement.id, { wordWrap: e.target.value })}
                                    size="sm">
                                    {wordWrapOptions.map((wrap) => (
                                       <option key={wrap.value} value={wrap.value}>
                                          {wrap.label}
                                       </option>
                                    ))}
                                 </Select>
                              </FormControl>

                              <FormControl>
                                 <FormLabel fontSize="sm">White Space</FormLabel>
                                 <Select
                                    value={selectedElement.whiteSpace || 'nowrap'}
                                    onChange={(e) => updateElement(selectedElement.id, { whiteSpace: e.target.value })}
                                    size="sm">
                                    {whiteSpaceOptions.map((space) => (
                                       <option key={space.value} value={space.value}>
                                          {space.label}
                                       </option>
                                    ))}
                                 </Select>
                              </FormControl>

                              {/* Word Wrap Toggle Buttons for Quick Access */}
                              <HStack spacing={2}>
                                 <Button
                                    size="sm"
                                    variant={selectedElement.whiteSpace === 'nowrap' ? 'solid' : 'outline'}
                                    colorScheme="blue"
                                    onClick={() =>
                                       updateElement(selectedElement.id, {
                                          whiteSpace: 'nowrap',
                                          wordWrap: 'normal',
                                       })
                                    }
                                    flex={1}>
                                    No Wrap
                                 </Button>
                                 <Button
                                    size="sm"
                                    variant={selectedElement.whiteSpace === 'pre-wrap' ? 'solid' : 'outline'}
                                    colorScheme="blue"
                                    onClick={() =>
                                       updateElement(selectedElement.id, {
                                          whiteSpace: 'pre-wrap',
                                          wordWrap: 'break-word',
                                       })
                                    }
                                    flex={1}>
                                    Wrap Text
                                 </Button>
                              </HStack>
                           </VStack>

                           {/* Color Controls */}
                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Text Color</FormLabel>
                                 <Input
                                    type="color"
                                    value={selectedElement.color}
                                    onChange={(e) => updateElement(selectedElement.id, { color: e.target.value })}
                                    h="40px"
                                 />
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Background Color</FormLabel>
                                 <Input
                                    type="color"
                                    value={selectedElement.backgroundColor || '#ffffff'}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { backgroundColor: e.target.value })
                                    }
                                    h="40px"
                                 />
                              </FormControl>
                           </HStack>

                           {/* NEW: Text Transform and Line Height */}
                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Text Transform</FormLabel>
                                 <Select
                                    value={selectedElement.textTransform || 'none'}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { textTransform: e.target.value })
                                    }
                                    size="sm">
                                    <option value="none">None</option>
                                    <option value="uppercase">UPPERCASE</option>
                                    <option value="lowercase">lowercase</option>
                                    <option value="capitalize">Capitalize</option>
                                 </Select>
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Line Height</FormLabel>
                                 <Input
                                    type="number"
                                    step="0.1"
                                    min="0.5"
                                    max="3"
                                    value={selectedElement.lineHeight || 1.2}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { lineHeight: parseFloat(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                           </HStack>

                           {/* NEW: Letter Spacing and Border Radius */}
                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Letter Spacing (px)</FormLabel>
                                 <Input
                                    type="number"
                                    step="0.1"
                                    min="-5"
                                    max="10"
                                    value={selectedElement.letterSpacing || 0}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { letterSpacing: parseFloat(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Border Radius (px)</FormLabel>
                                 <Input
                                    type="number"
                                    min="0"
                                    max="50"
                                    value={selectedElement.borderRadius || 0}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { borderRadius: parseInt(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                           </HStack>

                           {/* NEW: Border Properties */}
                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Border Width (px)</FormLabel>
                                 <Input
                                    type="number"
                                    min="0"
                                    max="10"
                                    value={selectedElement.borderWidth || 0}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { borderWidth: parseInt(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Border Color</FormLabel>
                                 <Input
                                    type="color"
                                    value={selectedElement.borderColor || '#000000'}
                                    onChange={(e) => updateElement(selectedElement.id, { borderColor: e.target.value })}
                                    h="40px"
                                 />
                              </FormControl>
                           </HStack>

                           {/* NEW: Border Style and Padding */}
                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Border Style</FormLabel>
                                 <Select
                                    value={selectedElement.borderStyle || 'solid'}
                                    onChange={(e) => updateElement(selectedElement.id, { borderStyle: e.target.value })}
                                    size="sm">
                                    <option value="solid">Solid</option>
                                    <option value="dashed">Dashed</option>
                                    <option value="dotted">Dotted</option>
                                    <option value="double">Double</option>
                                    <option value="groove">Groove</option>
                                    <option value="ridge">Ridge</option>
                                    <option value="inset">Inset</option>
                                    <option value="outset">Outset</option>
                                 </Select>
                              </FormControl>
                              <FormControl>
                                 <FormLabel fontSize="sm">Padding (px)</FormLabel>
                                 <Input
                                    type="number"
                                    min="0"
                                    max="50"
                                    value={selectedElement.padding || 0}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { padding: parseInt(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                           </HStack>

                           {/* NEW: Opacity and Shadow */}
                           <HStack spacing={4}>
                              <FormControl>
                                 <FormLabel fontSize="sm">Opacity</FormLabel>
                                 <Input
                                    type="number"
                                    step="0.1"
                                    min="0"
                                    max="1"
                                    value={selectedElement.opacity || 1}
                                    onChange={(e) =>
                                       updateElement(selectedElement.id, { opacity: parseFloat(e.target.value) })
                                    }
                                    size="sm"
                                 />
                              </FormControl>
                           </HStack>
                           {selectedElement.type === 'image' && renderImageProperties(selectedElement)}
                           {selectedElement.type === 'line' && (
                              <>
                                 <Divider />
                                 <Heading size="sm">Line Settings</Heading>
                                 <VStack spacing={4} align="stretch">
                                    <FormControl>
                                       <FormLabel fontSize="sm">Color</FormLabel>
                                       <Input
                                          type="color"
                                          value={selectedElement.color || '#000000'}
                                          onChange={(e) => updateElement(selectedElement.id, { color: e.target.value })}
                                          h="32px"
                                       />
                                    </FormControl>

                                    <HStack spacing={4}>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Width</FormLabel>
                                          <NumberInput
                                             size="sm"
                                             min={1}
                                             max={1000}
                                             value={selectedElement.width}
                                             onChange={(value) =>
                                                updateElement(selectedElement.id, { width: parseInt(value) })
                                             }>
                                             <NumberInputField />
                                             <NumberInputStepper>
                                                <NumberIncrementStepper />
                                                <NumberDecrementStepper />
                                             </NumberInputStepper>
                                          </NumberInput>
                                       </FormControl>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Thickness</FormLabel>
                                          <NumberInput
                                             size="sm"
                                             min={1}
                                             max={20}
                                             value={selectedElement.height}
                                             onChange={(value) =>
                                                updateElement(selectedElement.id, { height: parseInt(value) })
                                             }>
                                             <NumberInputField />
                                             <NumberInputStepper>
                                                <NumberIncrementStepper />
                                                <NumberDecrementStepper />
                                             </NumberInputStepper>
                                          </NumberInput>
                                       </FormControl>
                                    </HStack>

                                    <FormControl>
                                       <FormLabel fontSize="sm">Rotation (degrees)</FormLabel>
                                       <NumberInput
                                          value={selectedElement.rotation || 0}
                                          onChange={(valueString, valueNumber) =>
                                             updateElement(selectedElement.id, {
                                                rotation: isNaN(valueNumber) ? 0 : valueNumber,
                                             })
                                          }
                                          min={0}
                                          max={360}
                                          step={1}
                                          size="sm"
                                          width="80px">
                                          <NumberInputField />
                                          <NumberInputStepper>
                                             <NumberIncrementStepper />
                                             <NumberDecrementStepper />
                                          </NumberInputStepper>
                                       </NumberInput>
                                       <Slider
                                          value={selectedElement.rotation || 0}
                                          onChange={(value) => updateElement(selectedElement.id, { rotation: value })}
                                          min={0}
                                          max={360}
                                          step={1}
                                          colorScheme="blue">
                                          <SliderTrack>
                                             <SliderFilledTrack />
                                          </SliderTrack>
                                          <SliderThumb />
                                       </Slider>
                                    </FormControl>
                                 </VStack>
                              </>
                           )}

                           {/* Table-specific properties */}
                           {selectedElement.type === 'table' && (
                              <>
                                 <Divider />
                                 <Heading size="sm">Table Settings</Heading>

                                 <VStack spacing={4} align="stretch">
                                    {/* Basic Table Settings */}
                                    <HStack justify="space-between">
                                       <Text fontSize="sm">Show Borders</Text>
                                       <Checkbox
                                          isChecked={selectedElement.showBorders}
                                          onChange={(e) =>
                                             updateElement(selectedElement.id, { showBorders: e.target.checked })
                                          }
                                          colorScheme="blue"
                                       />
                                    </HStack>

                                    <HStack justify="space-between">
                                       <Text fontSize="sm">Show Column Lines</Text>
                                       <Checkbox
                                          isChecked={selectedElement.showColumnLines}
                                          onChange={(e) =>
                                             updateElement(selectedElement.id, { showColumnLines: e.target.checked })
                                          }
                                          colorScheme="blue"
                                       />
                                    </HStack>

                                    <HStack justify="space-between">
                                       <Text fontSize="sm">Alternate Row Colors</Text>
                                       <Checkbox
                                          isChecked={selectedElement.alternateRowColors}
                                          onChange={(e) =>
                                             updateElement(selectedElement.id, { alternateRowColors: e.target.checked })
                                          }
                                          colorScheme="blue"
                                       />
                                    </HStack>

                                    <HStack justify="space-between">
                                       <Text fontSize="sm">Sticky Header</Text>
                                       <Checkbox
                                          isChecked={selectedElement.stickyHeader}
                                          onChange={(e) =>
                                             updateElement(selectedElement.id, { stickyHeader: e.target.checked })
                                          }
                                          colorScheme="blue"
                                       />
                                    </HStack>

                                    {/* Header Styling */}
                                    <FormControl>
                                       <FormLabel fontSize="sm">Header Background</FormLabel>
                                       <Input
                                          type="color"
                                          value={selectedElement.headerStyle?.backgroundColor || '#f1f5f9'}
                                          onChange={(e) =>
                                             updateElement(selectedElement.id, {
                                                headerStyle: {
                                                   ...selectedElement.headerStyle,
                                                   backgroundColor: e.target.value,
                                                },
                                             })
                                          }
                                          h="32px"
                                       />
                                    </FormControl>

                                    <HStack spacing={4}>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Header Text Color</FormLabel>
                                          <Input
                                             type="color"
                                             value={selectedElement.headerStyle?.color || '#000000'}
                                             onChange={(e) =>
                                                updateElement(selectedElement.id, {
                                                   headerStyle: {
                                                      ...selectedElement.headerStyle,
                                                      color: e.target.value,
                                                   },
                                                })
                                             }
                                             h="32px"
                                          />
                                       </FormControl>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Header Font Size</FormLabel>
                                          <NumberInput
                                             size="sm"
                                             min={8}
                                             max={24}
                                             value={selectedElement.headerStyle?.fontSize || 11}
                                             onChange={(value) =>
                                                updateElement(selectedElement.id, {
                                                   headerStyle: {
                                                      ...selectedElement.headerStyle,
                                                      fontSize: parseInt(value),
                                                   },
                                                })
                                             }>
                                             <NumberInputField />
                                             <NumberInputStepper>
                                                <NumberIncrementStepper />
                                                <NumberDecrementStepper />
                                             </NumberInputStepper>
                                          </NumberInput>
                                       </FormControl>
                                    </HStack>

                                    {/* Row Colors */}
                                    <HStack spacing={4}>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Even Row Color</FormLabel>
                                          <Input
                                             type="color"
                                             value={selectedElement.evenRowColor || '#ffffff'}
                                             onChange={(e) =>
                                                updateElement(selectedElement.id, { evenRowColor: e.target.value })
                                             }
                                             h="32px"
                                          />
                                       </FormControl>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Odd Row Color</FormLabel>
                                          <Input
                                             type="color"
                                             value={selectedElement.oddRowColor || '#f8f9fa'}
                                             onChange={(e) =>
                                                updateElement(selectedElement.id, { oddRowColor: e.target.value })
                                             }
                                             h="32px"
                                          />
                                       </FormControl>
                                    </HStack>

                                    {/* Table Dimensions */}
                                    <HStack spacing={4}>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Table Width (px)</FormLabel>
                                          <NumberInput
                                             size="sm"
                                             min={100}
                                             max={1000}
                                             value={selectedElement.width}
                                             onChange={(value) =>
                                                updateElement(selectedElement.id, { width: parseInt(value) })
                                             }>
                                             <NumberInputField />
                                             <NumberInputStepper>
                                                <NumberIncrementStepper />
                                                <NumberDecrementStepper />
                                             </NumberInputStepper>
                                          </NumberInput>
                                       </FormControl>
                                       <FormControl>
                                          <FormLabel fontSize="sm">Row Height (px)</FormLabel>
                                          <NumberInput
                                             size="sm"
                                             min={20}
                                             max={60}
                                             value={selectedElement.rowHeight || 30}
                                             onChange={(value) =>
                                                updateElement(selectedElement.id, { rowHeight: parseInt(value) })
                                             }>
                                             <NumberInputField />
                                             <NumberInputStepper>
                                                <NumberIncrementStepper />
                                                <NumberDecrementStepper />
                                             </NumberInputStepper>
                                          </NumberInput>
                                       </FormControl>
                                    </HStack>

                                    {/* Row Management */}
                                    <Divider />
                                    <TableRowManagement element={selectedElement} />
                                 </VStack>

                                 {/* Table Fields Section */}
                                 <Divider />
                                 <HStack justify="space-between" align="center">
                                    <Heading size="sm">
                                       Table Fields ({selectedElement.tableFields?.length || 0})
                                    </Heading>
                                    <Button
                                       size="sm"
                                       colorScheme="blue"
                                       leftIcon={<Plus size={14} />}
                                       onClick={() => addTableField(selectedElement.id)}>
                                       Add Field
                                    </Button>
                                 </HStack>

                                 <VStack spacing={3} align="stretch" mt={4}>
                                    {selectedElement.tableFields?.map((field, index) => (
                                       <Box
                                          key={field.id}
                                          border="1px solid"
                                          borderColor="gray.200"
                                          borderRadius="md"
                                          p={3}
                                          bg={selectedTableField?.id === field.id ? 'blue.50' : 'white'}>
                                          <HStack justify="space-between" mb={2}>
                                             <HStack>
                                                <Badge colorScheme="blue">{index + 1}</Badge>
                                                <Text fontSize="sm" fontWeight="medium">
                                                   {field.label || `Field ${index + 1}`}
                                                </Text>
                                                <Badge ml={2} colorScheme={field.required ? 'red' : 'gray'}>
                                                   {field.required ? 'Required' : 'Optional'}
                                                </Badge>
                                             </HStack>
                                             <HStack>
                                                <IconButton
                                                   size="xs"
                                                   icon={<ChevronUp size={12} />}
                                                   onClick={() => moveTableField(selectedElement.id, field.id, 'up')}
                                                   isDisabled={index === 0}
                                                   aria-label="Move field up"
                                                />
                                                <IconButton
                                                   size="xs"
                                                   icon={<ChevronDown size={12} />}
                                                   onClick={() => moveTableField(selectedElement.id, field.id, 'down')}
                                                   isDisabled={index === selectedElement.tableFields.length - 1}
                                                   aria-label="Move field down"
                                                />
                                                <IconButton
                                                   size="xs"
                                                   icon={<Edit size={12} />}
                                                   onClick={() => setSelectedTableField(field)}
                                                   colorScheme="blue"
                                                   aria-label="Edit field"
                                                />
                                                <IconButton
                                                   size="xs"
                                                   icon={<Trash2 size={12} />}
                                                   onClick={() => deleteTableField(selectedElement.id, field.id)}
                                                   colorScheme="red"
                                                   aria-label="Delete field"
                                                />
                                             </HStack>
                                          </HStack>

                                          <VStack spacing={2} align="stretch">
                                             {/* Field Basic Properties */}
                                             <HStack spacing={2}>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Id</FormLabel>
                                                   <Input
                                                      size="xs"
                                                      value={field.id}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            id: e.target.value,
                                                         })
                                                      }
                                                      placeholder="Id"
                                                   />
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Label</FormLabel>
                                                   <Input
                                                      size="xs"
                                                      value={field.label}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            label: e.target.value,
                                                         })
                                                      }
                                                      placeholder="Field label"
                                                   />
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Type</FormLabel>
                                                   <Select
                                                      size="xs"
                                                      value={field.type}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            type: e.target.value,
                                                         })
                                                      }>
                                                      {tableFieldTypes.map((type) => (
                                                         <option key={type.value} value={type.value}>
                                                            {type.label}
                                                         </option>
                                                      ))}
                                                   </Select>
                                                </FormControl>
                                             </HStack>

                                             {/* Field Layout Properties */}
                                             <HStack spacing={2}>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Width %</FormLabel>
                                                   <NumberInput
                                                      size="xs"
                                                      min={5}
                                                      max={100}
                                                      value={field.width}
                                                      onChange={(value) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            width: parseInt(value),
                                                         })
                                                      }>
                                                      <NumberInputField />
                                                      <NumberInputStepper>
                                                         <NumberIncrementStepper />
                                                         <NumberDecrementStepper />
                                                      </NumberInputStepper>
                                                   </NumberInput>
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Alignment</FormLabel>
                                                   <Select
                                                      size="xs"
                                                      value={field.alignment}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            alignment: e.target.value,
                                                         })
                                                      }>
                                                      <option value="left">Left</option>
                                                      <option value="center">Center</option>
                                                      <option value="right">Right</option>
                                                   </Select>
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Padding (px)</FormLabel>
                                                   <NumberInput
                                                      size="xs"
                                                      min={0}
                                                      max={20}
                                                      value={field.padding || 4}
                                                      onChange={(value) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            padding: parseInt(value),
                                                         })
                                                      }>
                                                      <NumberInputField />
                                                      <NumberInputStepper>
                                                         <NumberIncrementStepper />
                                                         <NumberDecrementStepper />
                                                      </NumberInputStepper>
                                                   </NumberInput>
                                                </FormControl>
                                             </HStack>

                                             {/* Field Styling */}
                                             <HStack spacing={2}>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Font Size</FormLabel>
                                                   <NumberInput
                                                      size="xs"
                                                      min={8}
                                                      max={24}
                                                      value={field.fontSize || 11}
                                                      onChange={(value) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            fontSize: parseInt(value),
                                                         })
                                                      }>
                                                      <NumberInputField />
                                                      <NumberInputStepper>
                                                         <NumberIncrementStepper />
                                                         <NumberDecrementStepper />
                                                      </NumberInputStepper>
                                                   </NumberInput>
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Font Weight</FormLabel>
                                                   <Select
                                                      size="xs"
                                                      value={field.fontWeight}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            fontWeight: e.target.value,
                                                         })
                                                      }>
                                                      <option value="normal">Normal</option>
                                                      <option value="bold">Bold</option>
                                                      <option value="lighter">Lighter</option>
                                                   </Select>
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Font Family</FormLabel>
                                                   <Select
                                                      size="xs"
                                                      value={field.fontFamily}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            fontFamily: e.target.value,
                                                         })
                                                      }>
                                                      {fontFamilyOptions.map((font) => (
                                                         <option key={font} value={font} style={{ fontFamily: font }}>
                                                            {font}
                                                         </option>
                                                      ))}
                                                   </Select>
                                                </FormControl>
                                             </HStack>

                                             <HStack spacing={2}>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Text Color</FormLabel>
                                                   <Input
                                                      size="xs"
                                                      type="color"
                                                      value={field.color || '#000000'}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            color: e.target.value,
                                                         })
                                                      }
                                                   />
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Background</FormLabel>
                                                   <Input
                                                      size="xs"
                                                      type="color"
                                                      value={field.backgroundColor || '#ffffff'}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            backgroundColor: e.target.value,
                                                         })
                                                      }
                                                   />
                                                </FormControl>
                                             </HStack>

                                             {/* Field Borders */}
                                             <HStack spacing={2}>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Border Color</FormLabel>
                                                   <Input
                                                      size="xs"
                                                      type="color"
                                                      value={field.borderColor || '#e2e8f0'}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            borderColor: e.target.value,
                                                         })
                                                      }
                                                   />
                                                </FormControl>
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Border Width (px)</FormLabel>
                                                   <NumberInput
                                                      size="xs"
                                                      min={0}
                                                      max={5}
                                                      value={field.borderWidth || 1}
                                                      onChange={(value) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            borderWidth: parseInt(value),
                                                         })
                                                      }>
                                                      <NumberInputField />
                                                      <NumberInputStepper>
                                                         <NumberIncrementStepper />
                                                         <NumberDecrementStepper />
                                                      </NumberInputStepper>
                                                   </NumberInput>
                                                </FormControl>
                                             </HStack>

                                             {/* Field Options */}
                                             <FormControl>
                                                <FormLabel fontSize="xs">Placeholder</FormLabel>
                                                <Input
                                                   size="xs"
                                                   value={field.placeholder || ''}
                                                   onChange={(e) =>
                                                      updateTableField(selectedElement.id, field.id, {
                                                         placeholder: e.target.value,
                                                      })
                                                   }
                                                   placeholder="Field placeholder text"
                                                />
                                             </FormControl>

                                             <HStack justify="space-between">
                                                <Text fontSize="xs">Required Field</Text>
                                                <Checkbox
                                                   size="sm"
                                                   isChecked={field.required}
                                                   onChange={(e) =>
                                                      updateTableField(selectedElement.id, field.id, {
                                                         required: e.target.checked,
                                                      })
                                                   }
                                                   colorScheme="blue"
                                                />
                                             </HStack>

                                             {/* Type-specific options */}
                                             {field.type === 'select' && (
                                                <FormControl>
                                                   <FormLabel fontSize="xs">Options (comma separated)</FormLabel>
                                                   <Input
                                                      size="xs"
                                                      value={field.options ? field.options.join(', ') : ''}
                                                      onChange={(e) =>
                                                         updateTableField(selectedElement.id, field.id, {
                                                            options: e.target.value.split(',').map((opt) => opt.trim()),
                                                         })
                                                      }
                                                      placeholder="Option 1, Option 2, Option 3"
                                                   />
                                                </FormControl>
                                             )}

                                             {field.type === 'number' && (
                                                <HStack spacing={2}>
                                                   <FormControl>
                                                      <FormLabel fontSize="xs">Min Value</FormLabel>
                                                      <Input
                                                         size="xs"
                                                         type="number"
                                                         value={field.min}
                                                         onChange={(e) =>
                                                            updateTableField(selectedElement.id, field.id, {
                                                               min: parseFloat(e.target.value),
                                                            })
                                                         }
                                                      />
                                                   </FormControl>
                                                   <FormControl>
                                                      <FormLabel fontSize="xs">Max Value</FormLabel>
                                                      <Input
                                                         size="xs"
                                                         type="number"
                                                         value={field.max}
                                                         onChange={(e) =>
                                                            updateTableField(selectedElement.id, field.id, {
                                                               max: parseFloat(e.target.value),
                                                            })
                                                         }
                                                      />
                                                   </FormControl>
                                                </HStack>
                                             )}
                                          </VStack>
                                       </Box>
                                    ))}
                                 </VStack>
                              </>
                           )}
                        </VStack>
                     ) : (
                        <VStack spacing={4} align="center" py={8} color="gray.500">
                           <Settings size={48} opacity={0.5} />
                           <Text>`Select an element to {button} its properties`</Text>
                        </VStack>
                     )}
                  </TabPanel>
               </TabPanels>
            </Tabs>

            {/* Action Buttons */}
            <Box borderTop="1px solid" borderColor={borderColor} p={4}>
               <VStack spacing={2}>
                  <Button onClick={onOpen} colorScheme="blue" w="full" leftIcon={<Eye size={16} />}>
                     Preview
                  </Button>
                  <Button
                     onClick={generatePDF}
                     colorScheme="green"
                     w="full"
                     leftIcon={<Download size={16} />}
                     isLoading={isGenerating}
                     loadingText="Generating...">
                     Export PDF
                  </Button>
               </VStack>
            </Box>
         </Box>

         {/* Canvas */}
         <Box flex={1} position="relative" overflow="hidden">
            <Box
               ref={canvasRef}
               w="full"
               h="full"
               position="relative"
               bg="white"
               style={{
                  backgroundImage: showGrid
                     ? `linear-gradient(to right, #f0f0f0 1px, transparent 1px),
                 linear-gradient(to bottom, #f0f0f0 1px, transparent 1px)`
                     : 'none',
                  backgroundSize: showGrid ? `${10 * zoom}px ${10 * zoom}px` : 'auto',
               }}
               onMouseMove={handleMouseMove}
               onMouseUp={handleMouseUp}
               onMouseLeave={handleMouseUp}>
               {/* A4 Paper simulation */}
               <ElementSelectorDrawer
                  elements={elements}
                  onElementSelect={handleElementSelect}
                  selectedElement={selectedElement}
               />
               <Box
                  position="absolute"
                  left="50px"
                  top="50px"
                  width={`${getPageWidth(elements)}px`}
                  height={`${getPageHeight(elements)}px`}
                  bg="white"
                  shadow="lg"
                  border="1px solid"
                  borderColor="gray.300">
                  {elements && elements.elements && elements.elements.map((element) => renderElement(element))}
               </Box>
            </Box>
         </Box>

         {/* Preview Modal */}
         <PreviewModal />
         <QueryEditorPage
            initialQuery={queryText}
            setQueryText={setQueryText}
            onSave={handleQuerySave}
            isOpen={isQueryOpen}
            onClose={onQueryClose}
         />
      </Flex>
   );
};

export default InvoiceFormatEditor;
